// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:37:30.363Z
// Property: Park at Coulter (ID: 6767906449165615)
// Collections: 29 amenities, 6 floorplans (live), 49 photos, 56 POIs, 5 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165615",
  "property_external_id": "37732se",
  "property_zillow_url": "https://www.zillow.com/homedetails/5040-S-Coulter-St-Amarillo-TX-79119/122332929_zpid/",
  "property_apartments_url": "https://www.apartments.com/park-at-coulter-amarillo-tx/37732se/",
  "property_google_business_url": "https://www.google.com/maps/place/Park+at+Coulter/data=!4m2!3m1!1s0x0:0xcb366ecfa4ba2b59?sa=X&ved=2ahUKEwjnn-ye_LySAxV9nSYFHSYeAwQQ_BJ6BAg5EAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "park-at-coulter",
  "property_name": "Park at Coulter",
  "property_website_url": "https://www.caseusa.com/apartments/tx/amarillo/park-at-coulter/",
  "property_domain": null,
  "property_address": "5040 South Coulter St.",
  "property_full_address": "5040 South Coulter St., Amarillo, TX, 79119",
  "property_address_1": "5040 South Coulter St.",
  "property_address_2": null,
  "property_address_city": "Amarillo",
  "property_address_state": "TX",
  "property_address_zip_full": null,
  "property_address_zip": "79119",
  "property_address_country": "US",
  "property_address_county": "Randall County",
  "property_neighborhood_address": "Amarillo",
  "property_address_latitude": "35.1555",
  "property_address_longitude": "-101.9227",
  "property_email": "parkatcoulter@caseusa.com",
  "property_phone": "(806) 515-3550",
  "property_call_tracking_phone": "844-431-1044",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Park at Coulter in Amarillo, Texas, where modern living meets convenience. Choose from spacious one- and two-bedroom floor plans, and enjoy luxurious amenities like our welcoming clubhouse, refreshing pool, and vibrant dog park. Elevate your lifestyle—check our availability today or schedule a tour! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Park at Coulter, your ideal apartment community nestled in the heart of Amarillo, Texas! Our remarkable selection of floor plans features beautifully designed one and two-bedroom apartments, perfect for single residents or families alike. Each home is equipped with modern amenities that ensure comfort and convenience, including air conditioning, stainless steel appliances, and spacious walk-in closets. \n\nDiscover the perfect blend of relaxation and recreation with our onsite amenities. Take a refreshing dip in our shimmering pool or break a sweat in our fully-equipped fitness center. Unwind in our welcoming clubhouse, or let your furry friends run free in our dedicated dog park. Enjoy outdoor gatherings in our picnic area equipped with grills, or simply take in the serene landscapes from your private balcony or patio.\n\nAt Park at Coulter, we prioritize your convenience and peace of mind. Our professional management team is available onsite to assist you, while online services ensure hassle-free communication. Safety is paramount; our gated community offers an additional layer of security for you and your loved ones.\n\nExperience life like never before with nearby shopping, dining, and entertainment options that make Amarillo a vibrant place to call home. Don’t miss out on discovering your dream apartment! Find your new home today by browsing our availability or scheduling a personalized tour of our community. Come see why Park at Coulter is the perfect place for you and your family to thrive!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb45-06cc-725e-8f0c-c7db61a381d3.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
    "public_id": "019cfb45-06cc-725e-8f0c-c7db61a381d3",
    "storage_key": "property/6767906449165615/019cfb45-06cc-725e-8f0c-c7db61a381d3.webp",
    "width": 2048,
    "height": 1365
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "262",
  "property_year_built": "2013",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.18320610687023",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Contact Leasing office for details",
  "property_pet_policy_description": "Pets Welcome - Contact Leasing Office for details",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://parkatcoulterapartmentsamarillo.securecafe.com/onlineleasing/park-at-coulter/floorplans.aspx",
  "property_resident_portal_url": "https://parkatcoulterapartmentsamarillo.securecafe.com/residentservices/park-at-coulter/userlogin.aspx",
  "property_apply_now_url": "https://parkatcoulterapartmentsamarillo.securecafe.com/onlineleasing/park-at-coulter/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-c40f-77a5-94de-5b229f685290.webp",
  "property_primary_logo_media": {
    "alt_text": "The Park at Coulter Luxury Apartments logo.",
    "public_id": "019cfb43-c40f-77a5-94de-5b229f685290",
    "storage_key": "property/6767906449165615/019cfb43-c40f-77a5-94de-5b229f685290.webp",
    "width": 400,
    "height": 180
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-fc50-7151-866c-c7b1071d409f.webp",
  "property_secondary_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb44-fc50-7151-866c-c7b1071d409f",
    "storage_key": "property/6767906449165615/019cfb44-fc50-7151-866c-c7b1071d409f.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb45-17a5-7696-a2da-f4afcb9273c7.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Park at Coulter Luxury Apartments logo",
    "public_id": "019cfb45-17a5-7696-a2da-f4afcb9273c7",
    "storage_key": "property/6767906449165615/019cfb45-17a5-7696-a2da-f4afcb9273c7.webp",
    "width": 400,
    "height": 180
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb45-269c-77e5-8f6d-de34bb054553.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Park at Coulter Luxury Apartments logo.",
    "public_id": "019cfb45-269c-77e5-8f6d-de34bb054553",
    "storage_key": "property/6767906449165615/019cfb45-269c-77e5-8f6d-de34bb054553.webp",
    "width": 400,
    "height": 180
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#194f90",
  "property_secondary_color": "#00a0df",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": " - 1108",
  "property_sqft_min": "789",
  "property_sqft_max": "1108",
  "property_price_range": "1394 - 1590",
  "property_price_min": "1394",
  "property_price_max": "1590",
  "property_available_units": 10,
  "property_facebook_url": "https://www.facebook.com/parkatcoulter/photos/explore-luxury-living-in-southwest-amarillo-with-the-park-at-coulter-where-apart/732868248850487/",
  "property_instagram_url": "https://www.instagram.com/parkatcoulter/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ79tO-XZQAYcRWSu6pM9uNss",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/chasewood-apartments-amarillo",
  "property_tiktok_url": "https://www.tiktok.com/@parkatcoulteramarillo",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Park at Coulter",
  "property_home_romance_title": "Embrace Your New Beginning in a Charming Apartment Community",
  "property_home_amenities_blurb": "Elevate your lifestyle at Park at Coulter in Amarillo, Texas! Choose from spacious one and two-bedroom floor plans, while enjoying a vibrant community boasting a refreshing pool, a state-of-the-art fitness center, and serene picnic areas. Embrace convenience with on-site management and a welcoming dog park. Welcome home!",
  "property_home_floorplans_blurb": "Welcome to Park at Coulter in Amarillo, Texas, where comfort meets style. Choose from our inviting one and two-bedroom floor plans, thoughtfully designed to elevate your living experience. Your ideal apartment awaits—browse our selection and envision your next chapter in a vibrant community that feels like home.",
  "property_home_gallery_blurb": "Welcome to Park at Coulter, where modern living meets comfort in Amarillo, Texas. Choose from spacious one- and two-bedroom floor plans, and indulge in amenities like a refreshing pool, fitness center, and dog park. Picture yourself enjoying sunny afternoons in our landscaped courtyard or cozying up by the fireplace!",
  "property_home_neighborhood_blurb": "Nestled in vibrant Amarillo, the Park at Coulter offers spacious one and two-bedroom floor plans surrounded by rich culture and adventure. Enjoy nearby attractions like the Amarillo Botanical Gardens, Wildcat Bluff Nature Center, and the engaging Don Harrington Discovery Center, where excitement meets convenience. Uncover the local gems waiting for you!",
  "property_home_reviews_blurb": "Experience the charm of Park at Coulter in Amarillo, Texas, where residents rave about our \"gorgeous, spacious apartments\" and the friendly, dedicated management team. With a focus on community safety and beautiful surroundings, it’s no wonder our residents recommend us wholeheartedly. Join a place where you truly feel at home!",
  "property_neighborhood_blurb": "Nestled in vibrant Amarillo, Park at Coulter connects you to a world of adventure. From the serene landscapes of the Amarillo Botanical Gardens to the excitement of Urban Air Trampoline and Adventure Park, every day brings new opportunities to explore. Experience a community where convenience and leisure thrive. ",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Park at Coulter in Amarillo, Texas, luxury meets convenience. From spacious one- and two-bedroom floor plans to a vibrant dog park and sparkling pool, our community offers everything you need. Unwind in the clubhouse or stay active in the fitness center while enjoying high-speed internet and modern amenities.",
  "property_applynow_blurb": "At Park at Coulter, your dream lifestyle awaits in Amarillo, Texas. Choose from our spacious one or two-bedroom apartments, complete with modern amenities like a refreshing pool, inviting clubhouse, and convenient dog park. Embrace comfortable living and apply online today to secure your new home!",
  "property_contactus_blurb": "At Park at Coulter in Amarillo, Texas, we offer a variety of thoughtfully designed floor plans, including stylish one and two-bedroom apartments. Each home harmoniously blends comfort and modern living. For inquiries, reach out to our leasing team—we're here to help you find your ideal space!",
  "property_faqs_blurb": "At Park at Coulter in Amarillo, Texas, your ideal living space awaits. Whether you’re drawn to our cozy one-bedroom retreat or need the spaciousness of a two-bedroom suite, we have a floor plan that fits your lifestyle. Curious about our community? Browse our FAQs for all the insights you need!",
  "property_floorplans_blurb": "At Park at Coulter in Amarillo, Texas, our thoughtfully designed floor plans cater to your lifestyle. Choose from cozy one-bedroom retreats or spacious two-bedroom layouts, each crafted for comfort and convenience. Dive into our diverse options and find the ideal apartment home that perfectly suits your needs. ",
  "property_gallery_blurb": "At Park at Coulter in Amarillo, Texas, luxurious living meets comfort. With spacious one and two-bedroom floor plans, indulge in breathtaking amenities like a sparkling pool, fitness center, and a welcoming dog park. Picture yourself relaxing on your private balcony or enjoying vibrant social gatherings in our inviting clubhouse!",
  "property_interactivemap_blurb": "Unwind in the serene ambiance of Park at Coulter, where stylish one- and two-bedroom apartments meet luxurious amenities. Dive into our refreshing pool, stay fit in the fitness center, or enjoy a gathering in the clubhouse. Use our interactive community map to find the perfect space tailored to your lifestyle!",
  "property_pets_blurb": "Welcome to Park at Coulter, where vibrant living meets the heart of Amarillo, TX. Enjoy modern amenities and beautifully landscaped grounds tailored for you and your furry friends. With a pet-friendly policy, your beloved companions will feel right at home. Connect with us today for all the details!",
  "property_referafriend_blurb": "At Park at Coulter in Amarillo, Texas, vibrant living awaits in our spacious one- and two-bedroom apartments. With thoughtfully designed floor plans to suit your lifestyle, you'll feel right at home. Great friends make great neighbors—refer a friend to our community today and share the joy of exceptional living!",
  "property_residentaccess_blurb": "At Park at Coulter in Amarillo, Texas, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle. Enjoy seamless living with our resident portal—pay rent, schedule maintenance, and manage your home at your convenience. Log in now to elevate your apartment experience!",
  "property_reviews_blurb": "At Park at Coulter in Amarillo, residents celebrate their spacious, beautifully designed apartments and outstanding management. Our community shines with well-maintained grounds and dedicated staff ready to assist you. As one resident notes, “This is a beautiful place to live!” Find out what your future neighbors have to say!",
  "property_created_at": "1753982387840",
  "property_scheduletour_blurb": "At Park at Coulter in Amarillo, Texas, you'll find thoughtfully designed one and two-bedroom apartment floor plans tailored to your lifestyle. Experience the inviting community atmosphere and vibrant local culture. Curious about life here? Check out resident testimonials and schedule your tour today to see your future home!",
  "property_thankyou_blurb": "Thank you for your interest in Park at Coulter, where comfort meets style in Amarillo, Texas. Choose from our thoughtfully designed one and two-bedroom floor plans, tailored to suit your lifestyle. A team member will reach out soon to help you take the next step toward your new home!",
  "property_virtualtours_blurb": "At Park at Coulter in Amarillo, Texas, our thoughtfully designed one and two-bedroom apartments invite you to envision your perfect home. Dive into the details through our virtual tour and see how our vibrant community can complement your lifestyle. Your ideal living space awaits—take the tour today!",
  "property_copyright": "2025 All Rights Reserved. Park at Coulter",
  "property_seo_title_home": "Park at Coulter |  Apartments in Amarillo, Texas",
  "property_seo_description_home": "Unwind at Park at Coulter in Amarillo! Enjoy modern amenities, spacious layouts, and a vibrant community. Your perfect home awaits—come home today!",
  "property_seo_title_floorplans": "Floor Plans | Amarillo, Texas Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Park at Coulter in Amarillo, TX. Choose from stylish one and two-bedroom floor plans tailored for your lifestyle. Browse today!",
  "property_seo_title_amenities": "Amenities | Amarillo, Texas Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury living at Park at Coulter in Amarillo! Enjoy amenities like a refreshing pool and a welcoming dog park. Your dream home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Amarillo, Texas",
  "property_seo_description_gallery": "Experience life at Park at Coulter in Amarillo, TX! Stylish one and two-bedroom apartments with top-notch amenities. Picture your new home today!",
  "property_seo_title_virtualtours": "Virtual Tours | Park at Coulter Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Park at Coulter in Amarillo! Take a virtual tour and immerse yourself in our inviting one and two-bedroom apartments.",
  "property_seo_title_interactivemap": "Interactive Map | Park at Coulter Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Park at Coulter in Amarillo! Use our interactive map to explore spacious one and two-bedroom apartments with top-notch amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Amarillo, Texas",
  "property_seo_description_neighborhood": "Experience the charm of Amarillo from Park at Coulter! Uncover local favorites and nearby attractions that make your new home vibrant and inviting.",
  "property_seo_title_contact": "Contact Us | Park at Coulter",
  "property_seo_description_contact": "Reach out to Park at Coulter in Amarillo, TX! Our friendly leasing team is ready to help you find your dream one or two-bedroom apartment.",
  "property_seo_title_faqs": "FAQs | Apartments in Amarillo, Texas",
  "property_seo_description_faqs": "Unveil the perks of life at Park at Coulter! From spacious floor plans to top-notch amenities, find answers to all your burning questions on our FAQs page.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Amarillo, Texas",
  "property_seo_description_reviews": "Experience life at Park at Coulter in Amarillo! Find out what our residents love about our amenities, spacious apartments, and vibrant community.",
  "property_seo_title_applynow": "Apply Now | Apartments in Amarillo, Texas",
  "property_seo_description_applynow": "Welcome to Park at Coulter in Amarillo! Enjoy spacious one and two-bedroom apartments, top-notch amenities, and online leasing. Your perfect home awaits!",
  "property_seo_title_residentaccess": "Resident Access | Park at Coulter",
  "property_seo_description_residentaccess": "Effortlessly manage your home at Park at Coulter in Amarillo! Log in to your resident portal for seamless rent payment, maintenance requests, and more.",
  "property_seo_title_referafriend": "Refer A Friend | Park at Coulter",
  "property_seo_description_referafriend": "Refer a friend to Park at Coulter in Amarillo! Enjoy great neighbors & a vibrant community. Share the joy of living here—great friendships await!",
  "property_seo_title_scheduletour": "Schedule a Tour | Park at Coulter",
  "property_seo_description_scheduletour": "Experience the charm of Park at Coulter in Amarillo! Immerse yourself in our vibrant community—schedule a tour today and find your perfect home.",
  "property_seo_title_privacy": "Privacy Policy | Park at Coulter",
  "property_seo_description_privacy": "Your privacy matters at Park at Coulter in Amarillo. Learn how we protect your personal information with our comprehensive privacy policy. Stay informed!",
  "property_seo_title_accessibility": "Website Accessibility | Park at Coulter",
  "property_seo_description_accessibility": "Experience digital accessibility at Park at Coulter in Amarillo. We believe in inclusivity for all—join our community where everyone is welcome!",
  "property_seo_title_sitemap": "Sitemap | Park at Coulter",
  "property_seo_description_sitemap": "Uncover the layout of Park at Coulter in Amarillo, TX! Navigate through our sitemap to easily find the perfect home and community features waiting for you.",
  "property_seo_title_thankyou": "Thank You | Park at Coulter",
  "property_seo_description_thankyou": "Thank you for reaching out to Park at Coulter! Your inquiry is important to us—expect a warm welcome to your future home in Amarillo soon!",
  "property_seo_title_pets": "Pet Policy | Apartments in Amarillo, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865474872",
  "amenities": [
    {
      "id": "custom_0ebfcbdb-77e9-4094-af91-1c4084032f81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "external_id": "false",
      "title": "Grill and Chill Area with Outdoor Fireplace",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_29aa3485-ce90-4bd0-8b1d-2c0333627e54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1adda8a4-79f6-41b4-b509-2b79b3c9b42e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "external_id": "false",
      "title": "Limited‑Access Gates",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a5fb560e-19c4-4074-9953-334015cdf58a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "external_id": "false",
      "title": "Lush Well‑Lit Courtyard Grounds",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_aef7d0e0-0c55-4535-a3f6-7a6bc4278470",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "external_id": "false",
      "title": "Endurance Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fa139b63-fe77-4e74-b836-0eedd316ba57",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Emergency Maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1f234f6c-ef42-48ed-87ba-60bfd10ec370",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "external_id": "false",
      "title": "Garages Available*",
      "amount": "false",
      "description": "*In select homes",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d661c32e-a6cc-410e-843c-47bf244c46b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "external_id": "false",
      "title": "Professional Onsite Management",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e0e78ebd-a8f6-4961-8fb5-8bb2154c43fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Swimming Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6cd3b65b-4570-474b-aeef-b7aa26289ffa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "external_id": "false",
      "title": "Loft Style Living Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_60259eab-8b36-4a60-aca4-c94f7d27986d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "external_id": "false",
      "title": "Pet‑Friendly Community",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c7397b4f-01c5-4257-9c82-73828e58cfdd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "external_id": "false",
      "title": "Bark Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e79bba37-0b9f-4180-88ae-86816d8e9f08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "external_id": "false",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bc0bf708-a894-47ff-856d-39a6243e2fa6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rental Payments",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f50b3525-3a55-41a1-82af-488fecd8b585",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "external_id": "false",
      "title": "Plush Carpeting",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_61f186ae-7d8e-4a4d-826c-c6f59b184799",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e98b3520-cfc1-4893-97c8-ac9063449c76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "external_id": "false",
      "title": "Gourmet Kitchens with Stainless Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cfd6f183-c906-40f8-9600-70ec4dd3f7f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "external_id": "false",
      "title": "Storage*",
      "amount": "false",
      "description": "*In select homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_49a76e5c-1e80-480d-81ed-a98026dc2522",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "external_id": "false",
      "title": "Slate Ceramic Flooring in Kitchen & Baths",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_76fcfa10-cd73-440c-8622-2a58188ea91c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "external_id": "false",
      "title": "Vaulted Ceilings*",
      "amount": "false",
      "description": "*In select homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0bd5e74e-c3e1-4d8b-8bf5-75fc2f2481d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "external_id": "false",
      "title": "Large Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_56758e65-e135-4a34-9c84-31f527639a3d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Living Areas",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3540b994-b33f-47d9-b086-e79b07dd6a29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "external_id": "false",
      "title": "Private Balcony/Patio*",
      "amount": "false",
      "description": "*In select homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_365a5e24-ca3b-4638-aefb-a2f9b6dc5a34",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "external_id": "false",
      "title": "Washer & Dryer Connections",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0f4f2ca5-97c3-4c71-bed0-a52598ed26ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6514bd6c-656d-41b8-9684-e5ab81aba4df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "external_id": "false",
      "title": "Garages Available*",
      "amount": "false",
      "description": "*In select homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_45f878e9-3002-430d-a4ff-bf093dc0d051",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "external_id": "false",
      "title": "Get Connected To Super‑Fast Internet Powered by AT&T",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ba31d8e0-fab7-4179-a8fb-9b93ff9dfe15",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "external_id": "false",
      "title": "Custom Cabinetry",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4bcd383e-9c77-4896-8ba8-ea340abee33c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "external_id": "false",
      "title": "Fireplace",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_0ffd71b3-d957-404e-ac2c-e1ad37a29b7a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-504a-7291-8539-b06b116bf95e.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with picnic tables, umbrellas, grills, and a fireplace.",
        "public_id": "019d20af-504a-7291-8539-b06b116bf95e",
        "storage_key": "property/6767906449165615/019d20af-504a-7291-8539-b06b116bf95e.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Enjoy al fresco dining and gatherings in our community's outdoor entertainment space, complete with grills, comfortable seating, and a cozy fireplace.",
      "link": "",
      "alt_text": "Outdoor seating area with picnic tables, umbrellas, grills, and a fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165615/019cfb43-c48b-7789-bfe4-e2b7a1886306.webp"
    },
    {
      "id": "custom_098db7f3-27d8-4eca-b572-ef7e17cf9f0a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-504a-7291-8539-ae16e8ef73c4.webp",
      "image_media": {
        "alt_text": "Building exterior with stone accents, covered walkway, mailboxes, and landscaping.",
        "public_id": "019d20af-504a-7291-8539-ae16e8ef73c4",
        "storage_key": "property/6767906449165615/019d20af-504a-7291-8539-ae16e8ef73c4.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Exterior view of the community building featuring stone facade, covered entryway, and mailboxes.",
      "link": "",
      "alt_text": "Building exterior with stone accents, covered walkway, mailboxes, and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-42a5-70b4-8164-91b162ced106.webp"
    },
    {
      "id": "custom_31f18a3c-debe-4f29-b705-22d9791f3778",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-504f-75e9-8084-05219c3ad950.webp",
      "image_media": {
        "alt_text": "Dog park area at an apartment complex.",
        "public_id": "019d20af-504f-75e9-8084-05219c3ad950",
        "storage_key": "property/6767906449165615/019d20af-504f-75e9-8084-05219c3ad950.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "A fenced-in dog park area for residents, complete with agility equipment and waste disposal stations. A sign welcomes visitors to the 'Bark Park'.",
      "link": "",
      "alt_text": "Dog park area at an apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165615/019cfb43-cb67-70cb-93bb-9212c9f3ce9f.webp"
    },
    {
      "id": "custom_ec966a9d-3146-47af-88a7-a08e3ece2bca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-5058-70e8-a46d-d447df2b5aff.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and surrounding apartment buildings.",
        "public_id": "019d20af-5058-70e8-a46d-d447df2b5aff",
        "storage_key": "property/6767906449165615/019d20af-5058-70e8-a46d-d447df2b5aff.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling resort-style pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for relaxation and fun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and surrounding apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165615/019cfb43-ccc6-7453-a36d-82c7db10edfa.webp"
    },
    {
      "id": "custom_bfabb8e7-d704-456a-91f4-c7d9b99a8675",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-5b06-74c8-b1dc-f69496e42b03.webp",
      "image_media": {
        "alt_text": "Dog park area with a sign that says 'Welcome to the Bark Park at Coulter'",
        "public_id": "019d20af-5b06-74c8-b1dc-f69496e42b03",
        "storage_key": "property/6767906449165615/019d20af-5b06-74c8-b1dc-f69496e42b03.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Welcome your furry friends to the Bark Park at Coulter. This dedicated space provides a safe and fun environment for your pets to play and socialize.",
      "link": "",
      "alt_text": "Dog park area with a sign that says 'Welcome to the Bark Park at Coulter'",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-56f2-711a-a8d1-9b283c94cfbc.webp"
    },
    {
      "id": "custom_ba4ae2bb-934f-496e-8b75-e90098b70b55",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-5d02-75a7-9a60-bf6f4bfb630f.webp",
      "image_media": {
        "alt_text": "Balcony view overlooking the community's resort-style pool and buildings.",
        "public_id": "019d20af-5d02-75a7-9a60-bf6f4bfb630f",
        "storage_key": "property/6767906449165615/019d20af-5d02-75a7-9a60-bf6f4bfb630f.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Enjoy your morning coffee on your private balcony, with views of the resort-style pool and surrounding community.",
      "link": "",
      "alt_text": "Balcony view overlooking the community's resort-style pool and buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-6b63-7580-b97c-c3740c38889a.webp"
    },
    {
      "id": "custom_7bfbe74f-1395-4f9f-870d-4f5f84131624",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-5d48-7128-bb52-f5246cc25975.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a pergola and stone wall.",
        "public_id": "019d20af-5d48-7128-bb52-f5246cc25975",
        "storage_key": "property/6767906449165615/019d20af-5d48-7128-bb52-f5246cc25975.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Relax under the shade of the pergola on comfortable outdoor seating. Perfect for enjoying the fresh air.",
      "link": "",
      "alt_text": "Outdoor seating area with a pergola and stone wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-769c-7593-80a5-2c1133ee2a8b.webp"
    },
    {
      "id": "custom_88351ef5-8933-4840-9a94-5f2b8998f62e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-6079-717f-80e1-416fb4f8df83.webp",
      "image_media": {
        "alt_text": "Outdoor covered patio seating area with a pergola, sofa, chairs, and coffee table.",
        "public_id": "019d20af-6079-717f-80e1-416fb4f8df83",
        "storage_key": "property/6767906449165615/019d20af-6079-717f-80e1-416fb4f8df83.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish outdoor seating area, featuring a shaded pergola, comfortable sofas, and chairs perfect for enjoying the fresh air.",
      "link": "",
      "alt_text": "Outdoor covered patio seating area with a pergola, sofa, chairs, and coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-79f0-7446-83f8-6b3a8a25115e.webp"
    },
    {
      "id": "custom_5d5e8c76-d98e-4e5a-89cf-806b9a555666",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-6871-721a-90e1-b25c2ee860a2.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with sectional seating and a blue coffee table under a wooden pergola.",
        "public_id": "019d20af-6871-721a-90e1-b25c2ee860a2",
        "storage_key": "property/6767906449165615/019d20af-6871-721a-90e1-b25c2ee860a2.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Relax and unwind in the outdoor lounge area, complete with comfortable sectional seating and a stylish blue coffee table, all shaded by a charming wooden pergola.",
      "link": "",
      "alt_text": "Outdoor lounge area with sectional seating and a blue coffee table under a wooden pergola.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-7337-76ee-8168-e17f739038fd.webp"
    },
    {
      "id": "custom_25b974ac-0b0d-42e4-b2b6-325219dac6c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-6a6b-70df-a3ff-dbe66f69f1ef.webp",
      "image_media": {
        "alt_text": "Well-equipped fitness center with free weights, cardio machines, and weight machines.",
        "public_id": "019d20af-6a6b-70df-a3ff-dbe66f69f1ef",
        "storage_key": "property/6767906449165615/019d20af-6a6b-70df-a3ff-dbe66f69f1ef.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a wide range of exercise equipment for a complete workout.",
      "link": "",
      "alt_text": "Well-equipped fitness center with free weights, cardio machines, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-7f8b-702a-84ea-f511c04af9ff.webp"
    },
    {
      "id": "custom_c65976fa-6596-42c5-bb2f-232e7e80bec7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-6b09-760e-9c08-4f82ef5772e3.webp",
      "image_media": {
        "alt_text": "Spacious clubhouse lounge area with fireplace, seating, and a round dining table.",
        "public_id": "019d20af-6b09-760e-9c08-4f82ef5772e3",
        "storage_key": "property/6767906449165615/019d20af-6b09-760e-9c08-4f82ef5772e3.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully appointed clubhouse lounge, featuring a cozy fireplace and comfortable seating areas.",
      "link": "",
      "alt_text": "Spacious clubhouse lounge area with fireplace, seating, and a round dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-8631-70d8-a417-471eeb7d46fe.webp"
    },
    {
      "id": "custom_5dedb471-2d6f-4fd2-9ea1-7470a45d080e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-7527-75be-9af4-5cdacc24b305.webp",
      "image_media": {
        "alt_text": "Business center with computers, printer, and comfortable seating.",
        "public_id": "019d20af-7527-75be-9af4-5cdacc24b305",
        "storage_key": "property/6767906449165615/019d20af-7527-75be-9af4-5cdacc24b305.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Convenient business center with computers and printing facilities, perfect for residents needing to work or study.",
      "link": "",
      "alt_text": "Business center with computers, printer, and comfortable seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-7417-713a-8fbc-03155b884629.webp"
    },
    {
      "id": "custom_b7e15060-d26c-4649-94b9-81f89b00a914",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-76f6-740b-a830-f173cdf19606.webp",
      "image_media": {
        "alt_text": "Stylish community lounge with a fireplace, coffee bar, and comfortable seating.",
        "public_id": "019d20af-76f6-740b-a830-f173cdf19606",
        "storage_key": "property/6767906449165615/019d20af-76f6-740b-a830-f173cdf19606.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, featuring a cozy fireplace and a convenient coffee bar for your enjoyment.",
      "link": "",
      "alt_text": "Stylish community lounge with a fireplace, coffee bar, and comfortable seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-67b0-7109-9a19-0eb32d7f8e5a.webp"
    },
    {
      "id": "custom_9efdad4f-fcce-4e55-9a0c-f62e109ad9ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-7954-719a-86e6-bc72fe828085.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, sofa, coffee table, and dining area in the background.",
        "public_id": "019d20af-7954-719a-86e6-bc72fe828085",
        "storage_key": "property/6767906449165615/019d20af-7954-719a-86e6-bc72fe828085.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, comfortable sofa, and a dining area, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with a fireplace, sofa, coffee table, and dining area in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165615/019cfb43-cd49-75ab-bfce-a05554451bef.webp"
    },
    {
      "id": "custom_2552d2f4-2b14-4d59-8390-c22232afecf9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-7e83-7201-b895-bd563863fcd6.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019d20af-7e83-7201-b895-bd563863fcd6",
        "storage_key": "property/6767906449165615/019d20af-7e83-7201-b895-bd563863fcd6.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring dark cabinetry, granite countertops, stainless steel appliances, and ample storage space.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-3fc1-71dd-86f4-83b51fb81175.webp"
    },
    {
      "id": "custom_57f89988-2dc0-4a91-9337-e522e63cda1c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-84af-7558-978b-5f04e207cab0.webp",
      "image_media": {
        "alt_text": "Dining table with chairs and a desk with a chair in the background.",
        "public_id": "019d20af-84af-7558-978b-5f04e207cab0",
        "storage_key": "property/6767906449165615/019d20af-84af-7558-978b-5f04e207cab0.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A stylish dining area featuring a modern table and chairs, adjacent to a functional workspace with a desk and chair, perfect for both dining and remote work.",
      "link": "",
      "alt_text": "Dining table with chairs and a desk with a chair in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-4277-749b-a354-eb5b807f1ea2.webp"
    },
    {
      "id": "custom_bb77c24a-098c-4a29-ad04-3f5572cc14b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-8899-740c-82fc-dcdc03783b27.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, sofa, coffee table, and dining area.",
        "public_id": "019d20af-8899-740c-82fc-dcdc03783b27",
        "storage_key": "property/6767906449165615/019d20af-8899-740c-82fc-dcdc03783b27.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a cozy fireplace, comfortable sofa, and elegant dining space, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with a fireplace, sofa, coffee table, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-400b-730e-bdac-7b2a0de1d1cb.webp"
    },
    {
      "id": "custom_da47fa09-0828-419d-bb0b-3f97b43645bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-8ddc-71db-8eb4-f04d09939fcc.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019d20af-8ddc-71db-8eb4-f04d09939fcc",
        "storage_key": "property/6767906449165615/019d20af-8ddc-71db-8eb4-f04d09939fcc.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring dark wood cabinetry, granite countertops, stainless steel appliances, and ample counter space for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-3ff9-7196-b12d-31387fbc288f.webp"
    },
    {
      "id": "custom_d2b77370-baaf-4c0e-951f-086765d473ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-8f87-74f9-b5ef-eafb898f839f.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a dark wood vanity, marble countertop, and a large mirror.",
        "public_id": "019d20af-8f87-74f9-b5ef-eafb898f839f",
        "storage_key": "property/6767906449165615/019d20af-8f87-74f9-b5ef-eafb898f839f.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with ample counter space, modern fixtures, and a full-size bathtub with a shower.",
      "link": "",
      "alt_text": "Modern bathroom with a dark wood vanity, marble countertop, and a large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-3fdc-73ee-b84d-9e360c1b78d4.webp"
    },
    {
      "id": "custom_7ef0d2d3-f907-4a6d-9ddf-0b821444cf5e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-9505-72ea-8284-10456b63f5c5.webp",
      "image_media": {
        "alt_text": "Pet-friendly apartment amenities include a dog bed, food bowls, and a laundry basket.",
        "public_id": "019d20af-9505-72ea-8284-10456b63f5c5",
        "storage_key": "property/6767906449165615/019d20af-9505-72ea-8284-10456b63f5c5.webp",
        "width": 1280,
        "height": 1920
      },
      "title": "Apartment",
      "description": "Welcome your furry friends to this pet-friendly apartment, featuring a comfortable dog bed, convenient food bowls, and a stylish laundry basket.",
      "link": "",
      "alt_text": "Pet-friendly apartment amenities include a dog bed, food bowls, and a laundry basket.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-47af-72bc-abe3-ec91332d8086.webp"
    },
    {
      "id": "custom_496ff794-fdc5-4951-881c-57562ccacc2b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-955f-7740-b533-2a761c4291bd.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with white couch, coffee table, dining table, and bar seating.",
        "public_id": "019d20af-955f-7740-b533-2a761c4291bd",
        "storage_key": "property/6767906449165615/019d20af-955f-7740-b533-2a761c4291bd.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Stylish living and dining area with a modern kitchen featuring a breakfast bar. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room and kitchen area with white couch, coffee table, dining table, and bar seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-4295-70ad-b585-d19dece26037.webp"
    },
    {
      "id": "custom_fc6d78fd-e5b0-461e-871c-ddb6ff50af7a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-9995-7455-ae94-e5ded2936da0.webp",
      "image_media": {
        "alt_text": "Dog food station with dog portraits and supplies",
        "public_id": "019d20af-9995-7455-ae94-e5ded2936da0",
        "storage_key": "property/6767906449165615/019d20af-9995-7455-ae94-e5ded2936da0.webp",
        "width": 1280,
        "height": 1920
      },
      "title": "Apartment",
      "description": "A dedicated dog food station featuring dog portraits, a dog food bin, bowls, and treats, perfect for pet-friendly apartments.",
      "link": "",
      "alt_text": "Dog food station with dog portraits and supplies",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-479d-7087-ab3a-05539d74daaf.webp"
    },
    {
      "id": "custom_910feaa5-66f8-4f4f-89c7-d1a8ab8580dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-9b55-711e-8d67-1e7f41131efb.webp",
      "image_media": {
        "alt_text": "Dining area with a high-top table and two stools, next to a door with blinds.",
        "public_id": "019d20af-9b55-711e-8d67-1e7f41131efb",
        "storage_key": "property/6767906449165615/019d20af-9b55-711e-8d67-1e7f41131efb.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Enjoy your meals in the stylish dining area, perfect for intimate gatherings or a quick bite.",
      "link": "",
      "alt_text": "Dining area with a high-top table and two stools, next to a door with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-5256-71c0-b236-7092b00a6caf.webp"
    },
    {
      "id": "custom_7e6bf18e-078d-4f35-bb88-e24a07f8248c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-9f2d-732c-88f6-a543969a65dc.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white bathtub, black cabinetry, and decorative shower curtain.",
        "public_id": "019d20af-9f2d-732c-88f6-a543969a65dc",
        "storage_key": "property/6767906449165615/019d20af-9f2d-732c-88f6-a543969a65dc.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a deep soaking tub, elegant black vanity with a granite countertop, and stylish decorative accents.",
      "link": "",
      "alt_text": "Modern bathroom with a white bathtub, black cabinetry, and decorative shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-5252-70ff-af6e-28a7be7b6f67.webp"
    },
    {
      "id": "custom_310b97e9-fdc5-4e83-8c55-eb72f60876ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-9f51-734d-a9cb-1d90c72cc7a6.webp",
      "image_media": {
        "alt_text": "Open concept living and dining area with kitchen in background.",
        "public_id": "019d20af-9f51-734d-a9cb-1d90c72cc7a6",
        "storage_key": "property/6767906449165615/019d20af-9f51-734d-a9cb-1d90c72cc7a6.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious open-concept living and dining area, seamlessly connected to a modern kitchen, perfect for entertaining and everyday life.",
      "link": "",
      "alt_text": "Open concept living and dining area with kitchen in background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-547f-7531-a20f-9c30f3e4d0ea.webp"
    },
    {
      "id": "custom_f5f4f494-9435-4bc6-a863-7c6fdfdf631d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-a427-739d-a9ed-a85c50a15bd7.webp",
      "image_media": {
        "alt_text": "Empty closet with wire shelving and two storage baskets.",
        "public_id": "019d20af-a427-739d-a9ed-a85c50a15bd7",
        "storage_key": "property/6767906449165615/019d20af-a427-739d-a9ed-a85c50a15bd7.webp",
        "width": 1280,
        "height": 1920
      },
      "title": "Apartment",
      "description": "Spacious closet with ample wire shelving and decorative baskets, perfect for organizing your belongings.",
      "link": "",
      "alt_text": "Empty closet with wire shelving and two storage baskets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-54a7-758f-97ae-66c4f59a9c76.webp"
    },
    {
      "id": "custom_7b9fa56d-ff5a-47ef-b811-ee2873616388",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-a952-7213-83c6-2b645ddec919.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a king-size bed, wooden furniture, and decorative wall art.",
        "public_id": "019d20af-a952-7213-83c6-2b645ddec919",
        "storage_key": "property/6767906449165615/019d20af-a952-7213-83c6-2b645ddec919.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush king-size bed, ample storage, and charming decorative accents.",
      "link": "",
      "alt_text": "Stylish bedroom with a king-size bed, wooden furniture, and decorative wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-574e-730e-a43e-0034a281cca0.webp"
    },
    {
      "id": "custom_6dcb2dab-03b6-4dee-80b7-9c5b019a2e61",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-aa45-7386-9358-214dc8890a6a.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstands, dresser, and ceiling fan.",
        "public_id": "019d20af-aa45-7386-9358-214dc8890a6a",
        "storage_key": "property/6767906449165615/019d20af-aa45-7386-9358-214dc8890a6a.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious and well-lit bedroom featuring a plush king-size bed, elegant nightstands, a large dresser with a mirror, and a convenient ceiling fan for comfort.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstands, dresser, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-59b7-7309-9ea4-fcd4f6b1e1a3.webp"
    },
    {
      "id": "custom_7e2e298a-9ccb-45f1-9f24-663f27c211fe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-ac8b-7397-b657-e2185db304c2.webp",
      "image_media": {
        "alt_text": "Dining area with a high-top table and chairs, adjacent to a desk with a large print of a Highland cow.",
        "public_id": "019d20af-ac8b-7397-b657-e2185db304c2",
        "storage_key": "property/6767906449165615/019d20af-ac8b-7397-b657-e2185db304c2.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Enjoy a dedicated dining space and a stylish workspace, perfect for productivity and entertaining in your new apartment.",
      "link": "",
      "alt_text": "Dining area with a high-top table and chairs, adjacent to a desk with a large print of a Highland cow.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-578b-73cb-9b8a-65e8555e8aac.webp"
    },
    {
      "id": "custom_9303f8dc-f5cd-4768-a85e-e10edd1713a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-b033-7258-96d8-7eed542881a4.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, armchair, coffee table, and dining set.",
        "public_id": "019d20af-b033-7258-96d8-7eed542881a4",
        "storage_key": "property/6767906449165615/019d20af-b033-7258-96d8-7eed542881a4.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious living area featuring comfortable seating, a modern coffee table, and a dining nook, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with a sofa, armchair, coffee table, and dining set.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-5d6d-725d-b7aa-905525adc023.webp"
    },
    {
      "id": "custom_c346fa01-0692-4a16-8762-d8feef7bb7fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-b351-76e6-a77f-67d2527cb350.webp",
      "image_media": {
        "alt_text": "Living room with TV and kitchen counter with bar stools",
        "public_id": "019d20af-b351-76e6-a77f-67d2527cb350",
        "storage_key": "property/6767906449165615/019d20af-b351-76e6-a77f-67d2527cb350.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a TV, decorative accents, and a breakfast bar area with seating, perfect for entertaining.",
      "link": "",
      "alt_text": "Living room with TV and kitchen counter with bar stools",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-6496-7479-9410-37de294450e3.webp"
    },
    {
      "id": "custom_b55844d4-b1ce-4411-ab0b-5e44658abe28",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-b440-768a-8c47-ec2edcc7760f.webp",
      "image_media": {
        "alt_text": "Modern living room with a sectional sofa, armchair, coffee table, and dining area.",
        "public_id": "019d20af-b440-768a-8c47-ec2edcc7760f",
        "storage_key": "property/6767906449165615/019d20af-b440-768a-8c47-ec2edcc7760f.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Apartment",
      "description": "Step into comfort and style in this beautifully appointed living and dining space, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Modern living room with a sectional sofa, armchair, coffee table, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-65bb-77c9-a69f-7be120f439d1.webp"
    },
    {
      "id": "custom_99c669fd-c9da-41c5-b052-3af31415862d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-b8f3-71ee-9fa3-a4d2b3651816.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and a view into the bedroom.",
        "public_id": "019d20af-b8f3-71ee-9fa3-a4d2b3651816",
        "storage_key": "property/6767906449165615/019d20af-b8f3-71ee-9fa3-a4d2b3651816.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy living room with a fireplace and a view into a comfortable bedroom. Perfect for relaxing.",
      "link": "",
      "alt_text": "Living room with fireplace and a view into the bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-65d9-719d-9f25-0bb45fee5d1a.webp"
    },
    {
      "id": "custom_39e29a38-443b-443a-a9fd-677448d38362",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-be2c-74ed-8173-8ff02f101147.webp",
      "image_media": {
        "alt_text": "A well-appointed bedroom with a queen-sized bed, dresser, and fan.",
        "public_id": "019d20af-be2c-74ed-8173-8ff02f101147",
        "storage_key": "property/6767906449165615/019d20af-be2c-74ed-8173-8ff02f101147.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Relax in comfort in this inviting bedroom, featuring a plush queen-sized bed, ample storage, and a ceiling fan for your comfort.",
      "link": "",
      "alt_text": "A well-appointed bedroom with a queen-sized bed, dresser, and fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-67f8-77dd-92d1-dad204eed0e7.webp"
    },
    {
      "id": "custom_2bd4423b-f511-4652-b700-501540fbc829",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-befa-74aa-879d-24f3ffd46114.webp",
      "image_media": {
        "alt_text": "Bathroom with white tub, toilet, and dark vanity.",
        "public_id": "019d20af-befa-74aa-879d-24f3ffd46114",
        "storage_key": "property/6767906449165615/019d20af-befa-74aa-879d-24f3ffd46114.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A stylish bathroom featuring a white bathtub and toilet, complemented by a dark vanity with a marble-look countertop.",
      "link": "",
      "alt_text": "Bathroom with white tub, toilet, and dark vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-6b5b-7610-8bb3-d6ce2fcb2a4c.webp"
    },
    {
      "id": "custom_1295d8a8-3599-4d0c-8ca8-92fea9a53b49",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-c06b-7154-a2bb-632233efdc05.webp",
      "image_media": {
        "alt_text": "Dining area with a wooden table and chairs, large windows, and decorative lanterns.",
        "public_id": "019d20af-c06b-7154-a2bb-632233efdc05",
        "storage_key": "property/6767906449165615/019d20af-c06b-7154-a2bb-632233efdc05.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Enjoy meals in this charming dining area, featuring a warm wooden table and chairs, perfect for intimate dinners or family gatherings. Large windows fill the space with natural light.",
      "link": "",
      "alt_text": "Dining area with a wooden table and chairs, large windows, and decorative lanterns.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-72a1-7441-97a8-0ec3afe3d51e.webp"
    },
    {
      "id": "custom_b4160499-8beb-4006-a897-b8ddba530499",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-c8cf-73bc-ae10-82e0784240d2.webp",
      "image_media": {
        "alt_text": "King-size bed with decorative pillows, dresser with mirror, and ceiling fan.",
        "public_id": "019d20af-c8cf-73bc-ae10-82e0784240d2",
        "storage_key": "property/6767906449165615/019d20af-c8cf-73bc-ae10-82e0784240d2.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, ample storage with a dresser and mirror, and a ceiling fan for added comfort.",
      "link": "",
      "alt_text": "King-size bed with decorative pillows, dresser with mirror, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-7338-703d-9610-94a92f527581.webp"
    },
    {
      "id": "custom_1ee9d188-0e3d-48a4-991a-e7605717c74e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-c925-752d-903c-e2c741c13ea5.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and modern decor.",
        "public_id": "019d20af-c925-752d-903c-e2c741c13ea5",
        "storage_key": "property/6767906449165615/019d20af-c925-752d-903c-e2c741c13ea5.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A spacious and modern kitchen featuring dark wood cabinetry, elegant granite countertops, and stainless steel appliances. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-7eb0-7438-9205-59a75bc80a95.webp"
    },
    {
      "id": "custom_d4a2c318-9dba-473c-bc7c-9cd947d7eab3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-ca4f-735c-b2d0-dca9d857858f.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a king-size bed, plush bedding, bedside table with lamp, and a ceiling fan.",
        "public_id": "019d20af-ca4f-735c-b2d0-dca9d857858f",
        "storage_key": "property/6767906449165615/019d20af-ca4f-735c-b2d0-dca9d857858f.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a king-size bed, soft linens, and ambient lighting.",
      "link": "",
      "alt_text": "Cozy bedroom with a king-size bed, plush bedding, bedside table with lamp, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-80c5-704c-8c25-4b9652583094.webp"
    },
    {
      "id": "custom_df32b392-b42f-4afe-bf56-84458c27ed10",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-cb8b-70aa-9ea0-5d9c72375eb5.webp",
      "image_media": {
        "alt_text": "Dining room with a round table, four chairs, a large plant, and wall art.",
        "public_id": "019d20af-cb8b-70aa-9ea0-5d9c72375eb5",
        "storage_key": "property/6767906449165615/019d20af-cb8b-70aa-9ea0-5d9c72375eb5.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious dining area featuring a round table with seating for four, complemented by a tall potted plant and tasteful wall decor, perfect for everyday meals and entertaining.",
      "link": "",
      "alt_text": "Dining room with a round table, four chairs, a large plant, and wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-847e-749b-9c27-a7cd3ab0380b.webp"
    },
    {
      "id": "custom_c2e4ca3f-cfd6-4c30-9e0b-30ad6ab9afb0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-d357-727c-ac74-4540ea9dc00e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinetry, granite countertops, and stainless steel appliances.",
        "public_id": "019d20af-d357-727c-ac74-4540ea9dc00e",
        "storage_key": "property/6767906449165615/019d20af-d357-727c-ac74-4540ea9dc00e.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Experience culinary convenience in this stylish apartment kitchen, featuring sleek dark cabinets, elegant granite countertops, and a full suite of modern appliances.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinetry, granite countertops, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-866b-73d3-8c5e-1a899c4b6c5a.webp"
    },
    {
      "id": "custom_9661d7a9-0ffe-48ac-a24d-572282e7f019",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-d3c2-76fa-83e3-fb879ecd43d2.webp",
      "image_media": {
        "alt_text": "Living room with green sofa, coffee table, TV, and view into kitchen with island and stools.",
        "public_id": "019d20af-d3c2-76fa-83e3-fb879ecd43d2",
        "storage_key": "property/6767906449165615/019d20af-d3c2-76fa-83e3-fb879ecd43d2.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious and well-appointed living room featuring a modern green sofa, a stylish coffee table, and a large flat-screen TV. The open-concept layout seamlessly connects to a contemporary kitchen, complete with an island and bar stools, perfect for entertaining.",
      "link": "",
      "alt_text": "Living room with green sofa, coffee table, TV, and view into kitchen with island and stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-8896-7374-890f-998f8416cc90.webp"
    },
    {
      "id": "custom_37863478-ed29-4bde-814a-603d4bb4b112",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-d63c-779d-ac12-146cd6b9e0ff.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, dresser, and ceiling fan.",
        "public_id": "019d20af-d63c-779d-ac12-146cd6b9e0ff",
        "storage_key": "property/6767906449165615/019d20af-d63c-779d-ac12-146cd6b9e0ff.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a plush queen-size bed, a tall dresser, and a ceiling fan. Large windows provide ample natural light.",
      "link": "",
      "alt_text": "Bedroom with a bed, dresser, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-8c6a-705d-a7a7-9b89acf6aee7.webp"
    },
    {
      "id": "custom_81403b34-5ed7-4304-9cfc-123ec1071999",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-dca7-7194-801a-9a0fe5821ffe.webp",
      "image_media": {
        "alt_text": "Bathroom with a dark wood vanity, granite countertop, stainless steel sink, toilet, and bathtub with a white shower curtain.",
        "public_id": "019d20af-dca7-7194-801a-9a0fe5821ffe",
        "storage_key": "property/6767906449165615/019d20af-dca7-7194-801a-9a0fe5821ffe.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a spacious vanity with ample storage, a comfortable soaking tub, and elegant finishes.",
      "link": "",
      "alt_text": "Bathroom with a dark wood vanity, granite countertop, stainless steel sink, toilet, and bathtub with a white shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-8e2b-702f-80e2-0b4052fc08b4.webp"
    },
    {
      "id": "custom_f12f7c6b-2d83-4670-8639-420e79c7a469",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-dce4-7570-89fa-2cf1474a9b3b.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with wire shelving and two wicker baskets.",
        "public_id": "019d20af-dce4-7570-89fa-2cf1474a9b3b",
        "storage_key": "property/6767906449165615/019d20af-dce4-7570-89fa-2cf1474a9b3b.webp",
        "width": 1280,
        "height": 1920
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving and neutral carpeting, perfect for all your storage needs.",
      "link": "",
      "alt_text": "Empty walk-in closet with wire shelving and two wicker baskets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-5321-716a-96c3-c13038a235d3.webp"
    },
    {
      "id": "custom_f5536514-27de-40f1-877a-d4368c5d2140",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-e09d-73fa-a9de-7762e2ad19c4.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with shelving and a decorative basket.",
        "public_id": "019d20af-e09d-73fa-a9de-7762e2ad19c4",
        "storage_key": "property/6767906449165615/019d20af-e09d-73fa-a9de-7762e2ad19c4.webp",
        "width": 1280,
        "height": 1920
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving and a stylish woven basket, perfect for organizing your belongings.",
      "link": "",
      "alt_text": "Empty walk-in closet with shelving and a decorative basket.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-65c5-7750-8d33-cad07f88feaf.webp"
    },
    {
      "id": "custom_ecb05eba-9405-4d5c-a5b8-6f57c74bb537",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-e6e3-766d-8f08-e9e603c19f7f.webp",
      "image_media": {
        "alt_text": "The silhouette of the Tulsa, OK, skyline at sunset.",
        "public_id": "019d20af-e6e3-766d-8f08-e9e603c19f7f",
        "storage_key": "property/6767906449165615/019d20af-e6e3-766d-8f08-e9e603c19f7f.webp",
        "width": 1024,
        "height": 681
      },
      "title": "Lifestyle",
      "description": "The silhouette of the Tulsa, OK, skyline at sunset.",
      "link": "",
      "alt_text": "The silhouette of the Tulsa, OK, skyline at sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165615/019cfb43-cef7-76fa-8934-c9e24e5ae223.webp"
    },
    {
      "id": "custom_f465fb1f-77b7-439a-b526-11f057c119e4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-e843-7419-9dc2-f82001bcb49f.webp",
      "image_media": {
        "alt_text": "Old Town neighborhood in Wichita, KS, on a bright, sunny day.",
        "public_id": "019d20af-e843-7419-9dc2-f82001bcb49f",
        "storage_key": "property/6767906449165615/019d20af-e843-7419-9dc2-f82001bcb49f.webp",
        "width": 1024,
        "height": 576
      },
      "title": "Lifestyle",
      "description": "Old Town neighborhood in Wichita, KS, on a bright, sunny day.",
      "link": "",
      "alt_text": "Old Town neighborhood in Wichita, KS, on a bright, sunny day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165615/019cfb43-d0ad-713d-ac4c-09c9d7ab5341.webp"
    },
    {
      "id": "custom_45950ee6-9bf3-4b26-bead-38182ff3f30e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d20af-e87d-757b-ab9c-964273341c4c.webp",
      "image_media": {
        "alt_text": "The Keeper of the Plains at dawn, illuminated by an orange light.",
        "public_id": "019d20af-e87d-757b-ab9c-964273341c4c",
        "storage_key": "property/6767906449165615/019d20af-e87d-757b-ab9c-964273341c4c.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Lifestyle",
      "description": "The Keeper of the Plains at dawn, illuminated by an orange light.",
      "link": "",
      "alt_text": "The Keeper of the Plains at dawn, illuminated by an orange light.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165615/019cfb43-d18a-771a-9985-3441528808f8.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_6a78af25-9142-4cdf-aa73-15dbed5b9f28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "2805 I-40, Amarillo, TX 79109, USA",
      "poi_short_description": "Chain steakhouse serving fall-off-the-bone ribs and other American fare in a lively setting.",
      "poi_long_description": "People say this steakhouse serves tender chicken fried steak, delicious ribs, and flavorful ribeye steaks. They highlight the generous portions, reasonable prices, and the legendary rolls with cinnamon butter. They also like the friendly and attentive service provided by the staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-14f5-72d9-adda-ee05b3b9e0ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-14f5-72d9-adda-ee05b3b9e0ea",
        "storage_key": "property/6767906449165615/019cfb44-14f5-72d9-adda-ee05b3b9e0ea.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/texas/amarillo?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=3328858651283659231&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "35.1940532",
      "poi_longitude": "-101.8676751",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 806-352-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b68-75f8-9e36-f941bb6273d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b68-75f8-9e36-f941bb6273d1",
        "storage_key": "property/6767906449165615/019cfb44-2b68-75f8-9e36-f941bb6273d1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUQj8GMpPAYcR35k_aU57Mi4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_b4a2df7b-2e3b-4449-b1d4-cc5957a346cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Bubba's 33",
      "poi_type": "Restaurants",
      "poi_address": "2813 I-40, Amarillo, TX 79109, USA",
      "poi_short_description": "Laid-back chain serving burgers, beer and pizza, plus sports on multiple TVs.",
      "poi_long_description": "People say this American restaurant serves delicious burgers, pizza, and Philly cheese steaks. They highlight the generous portions, reasonable prices, and lively sports bar atmosphere with numerous TVs. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-14fe-7648-a7c3-233376d5f313.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-14fe-7648-a7c3-233376d5f313",
        "storage_key": "property/6767906449165615/019cfb44-14fe-7648-a7c3-233376d5f313.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.bubbas33.com/locations/texas/amarillo?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=15317791946731671629&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bubbas-33",
      "poi_latitude": "35.1937663",
      "poi_longitude": "-101.8691615",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 806-353-0033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b68-75f8-9e36-f941bb6273d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b68-75f8-9e36-f941bb6273d1",
        "storage_key": "property/6767906449165615/019cfb44-2b68-75f8-9e36-f941bb6273d1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD99rJspPAYcRTdBHUJ66k9Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_33dca4bf-3da7-4272-aa18-b2123b774c89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "2525 S Georgia St, Amarillo, TX 79109, USA",
      "poi_short_description": "Fast-food chain known for its chicken sandwiches and waffle fries, plus breakfast items and a kids' menu.",
      "poi_long_description": "People say this fast food restaurant serves tasty chicken sandwiches, nuggets, and lemonade. They highlight the friendly and attentive staff, and the quick service. They also like the clean atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-14f5-72d9-adda-f30a82c31759.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-14f5-72d9-adda-f30a82c31759",
        "storage_key": "property/6767906449165615/019cfb44-14f5-72d9-adda-f30a82c31759.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/tx/georgia-street?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=9898565818159840665&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "35.18604200000001",
      "poi_longitude": "-101.8656726",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 806-358-8055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b68-75f8-9e36-f941bb6273d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b68-75f8-9e36-f941bb6273d1",
        "storage_key": "property/6767906449165615/019cfb44-2b68-75f8-9e36-f941bb6273d1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJd_QXe7hPAYcRmb09sSrFXok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_6583845e-f4f9-495b-9f24-9d64638b5285",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "2812 S Georgia St, Amarillo, TX 79109, USA",
      "poi_short_description": "Casual chain eatery specializing in chicken fingers, fries and lemonade.",
      "poi_long_description": "People say this fast food restaurant serves great chicken fingers, and the tailgate trays are good for families. They highlight the fast service and the fresh, hot food. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-153a-7529-9161-249900c2dfbc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-153a-7529-9161-249900c2dfbc",
        "storage_key": "property/6767906449165615/019cfb44-153a-7529-9161-249900c2dfbc.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/tx/amarillo/2812-s-georgia-st",
      "poi_directions_map_url": "https://maps.google.com/?cid=905577921826965201&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "35.1828248",
      "poi_longitude": "-101.8668346",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 806-356-0140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b68-75f8-9e36-f941bb6273d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b68-75f8-9e36-f941bb6273d1",
        "storage_key": "property/6767906449165615/019cfb44-2b68-75f8-9e36-f941bb6273d1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvUy4qoxPAYcR0cbualJCkQw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_4cec1245-68a2-4e48-93d4-a20ce42c5c3d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Golden Corral Buffet & Grill",
      "poi_type": "Restaurants",
      "poi_address": "7220 I-40, Amarillo, TX 79106, USA",
      "poi_short_description": "Casual restaurant offering an all-you-can-eat buffet of familiar American dishes.",
      "poi_long_description": "People say this buffet restaurant offers a wide selection of fresh food, including steak, meatloaf, and a salad bar. They also highlight the friendly staff, clean environment, and good value, especially for the early bird special.\n\nOther reviews mention the food can be salty.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-14dc-73ba-8be0-4ba8bdd6f86d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-14dc-73ba-8be0-4ba8bdd6f86d",
        "storage_key": "property/6767906449165615/019cfb44-14dc-73ba-8be0-4ba8bdd6f86d.webp",
        "width": 960,
        "height": 721
      },
      "poi_business_url": "https://www.goldencorral.com/locations/533/golden-corral-interstate-40-west?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=533",
      "poi_directions_map_url": "https://maps.google.com/?cid=9190004277535110809&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golden-corral-buffet--grill",
      "poi_latitude": "35.18741079999999",
      "poi_longitude": "-101.9189781",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 806-353-3779",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b68-75f8-9e36-f941bb6273d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b68-75f8-9e36-f941bb6273d1",
        "storage_key": "property/6767906449165615/019cfb44-2b68-75f8-9e36-f941bb6273d1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlV3avU5QAYcRmfbMHjN0iX8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_1a3d59cc-3ce2-42d7-bd5b-500ca1c40cc7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Westgate Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "7701 I-40, Amarillo, TX 79121, USA",
      "poi_short_description": "Spacious shopping hub with familiar retailers and a cinema alongside an arcade and a playground.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores and a food court. They also highlight the clean and well-maintained environment.\n\nOther reviews mention it can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-14dc-73ba-8be0-44d8fb8b4d81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-14dc-73ba-8be0-44d8fb8b4d81",
        "storage_key": "property/6767906449165615/019cfb44-14dc-73ba-8be0-44d8fb8b4d81.webp",
        "width": 1280,
        "height": 606
      },
      "poi_business_url": "http://www.westgatemalltx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8872045046986861251&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "westgate-mall",
      "poi_latitude": "35.184043",
      "poi_longitude": "-101.9280617",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 806-358-7221",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b34-7049-8a35-895829bc383c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b34-7049-8a35-895829bc383c",
        "storage_key": "property/6767906449165615/019cfb44-2b34-7049-8a35-895829bc383c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5aNuwVBQAYcRw2rq0PbVH3s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_a1d72022-4c1c-48c3-8582-161f8b3e2a46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "2410 S Georgia St, Amarillo, TX 79109, USA",
      "poi_short_description": "Sprawling home-improvement chain stocking tools, appliances, lumber, furniture, flooring, paint and plants along with gardening supplies.",
      "poi_long_description": "People say this home improvement store has helpful and knowledgeable staff who are always willing to assist customers in finding the right products and completing their projects. They also highlight the wide selection of home furniture and supplies available at the store.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-1481-760a-9c63-6d28b491c08b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-1481-760a-9c63-6d28b491c08b",
        "storage_key": "property/6767906449165615/019cfb44-1481-760a-9c63-6d28b491c08b.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/E-Amarillo/TX/Amarillo/79109/6831?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=17449643067838617860&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "35.1887022",
      "poi_longitude": "-101.8687317",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 806-468-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b34-7049-8a35-895829bc383c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b34-7049-8a35-895829bc383c",
        "storage_key": "property/6767906449165615/019cfb44-2b34-7049-8a35-895829bc383c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_XrzAchPAYcRBNngA-uVKfI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_1d8577e4-c7cc-4bbb-b0dc-b002b29bc3d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Burlington",
      "poi_type": "Shopping & Retail",
      "poi_address": "2201 S Western St, Amarillo, TX 79109, USA",
      "poi_short_description": "Chains and department retailer featuring clothing and footwear, plus housewares and gifts.",
      "poi_long_description": "People say this clothing store offers a wide selection of clothing and shoes, including name brands. They also highlight the good prices and quality of the items.\n\nSome reviews mention the layout can be confusing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-1483-7508-b278-73d13a4eeccd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-1483-7508-b278-73d13a4eeccd",
        "storage_key": "property/6767906449165615/019cfb44-1483-7508-b278-73d13a4eeccd.webp",
        "width": 488,
        "height": 289
      },
      "poi_business_url": "https://stores.burlington.com/tx/amarillo/564/?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=13172599468811409494&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "burlington",
      "poi_latitude": "35.1892288",
      "poi_longitude": "-101.8809655",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 806-353-7087",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b34-7049-8a35-895829bc383c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b34-7049-8a35-895829bc383c",
        "storage_key": "property/6767906449165615/019cfb44-2b34-7049-8a35-895829bc383c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQYcDKddPAYcRVtgA62x5zrY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_fd0d2c53-48b9-4e2f-9740-caa3f0adc5db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Market Street",
      "poi_type": "Shopping & Retail",
      "poi_address": "2530 S Georgia St, Amarillo, TX 79109, USA",
      "poi_short_description": "Clean grocery store that’s stocked with national brands alongside local ingredients, and has an on-site bakery and deli.",
      "poi_long_description": "People say this grocery store offers a wide selection of groceries, meats, and ready-to-eat food. They highlight the reasonable prices and clean, well-stocked store. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-14da-723a-91c3-028365fe0e61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-14da-723a-91c3-028365fe0e61",
        "storage_key": "property/6767906449165615/019cfb44-14da-723a-91c3-028365fe0e61.webp",
        "width": 711,
        "height": 400
      },
      "poi_business_url": "https://local.marketstreetunited.com/tx/amarillo/2530-s-georgia-st.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=16028910684191050097&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "market-street",
      "poi_latitude": "35.1862872",
      "poi_longitude": "-101.8681069",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 806-468-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b62-74db-bfd2-df233cb029ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b62-74db-bfd2-df233cb029ff",
        "storage_key": "property/6767906449165615/019cfb44-2b62-74db-bfd2-df233cb029ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_27QvMdPAYcRccmrq1chct4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_7bbff4e5-f55b-4d32-92de-cfd06960b073",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "3030 S Soncy Rd, Amarillo, TX 79124, USA",
      "poi_short_description": "Chain selling discounted clothing, accessories and housewares.",
      "poi_long_description": "People say this clothing store offers a wide selection of items. They also highlight the affordable prices and friendly cashiers.\n\nOther reviews mention the lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-14dc-73ba-8be0-4d51fe56a0ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-14dc-73ba-8be0-4d51fe56a0ef",
        "storage_key": "property/6767906449165615/019cfb44-14dc-73ba-8be0-4d51fe56a0ef.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16582175913080698917&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "35.1797012",
      "poi_longitude": "-101.940193",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 806-355-8901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b34-7049-8a35-895829bc383c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b34-7049-8a35-895829bc383c",
        "storage_key": "property/6767906449165615/019cfb44-2b34-7049-8a35-895829bc383c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJf8ncs_lQAYcRJbg2BiO5H-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_8a853d60-878e-42d7-b702-e58786a13458",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Amarillo College",
      "poi_type": "Education",
      "poi_address": "2201 S Washington St #2411, Amarillo, TX 79109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-1862-76e9-a92d-51e85d80bcec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-1862-76e9-a92d-51e85d80bcec",
        "storage_key": "property/6767906449165615/019cfb44-1862-76e9-a92d-51e85d80bcec.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.actx.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12362103176866188035&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amarillo-college",
      "poi_latitude": "35.1877711",
      "poi_longitude": "-101.8482546",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 806-371-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b0d-7339-96c2-497a13e748bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b0d-7339-96c2-497a13e748bf",
        "storage_key": "property/6767906449165615/019cfb44-2b0d-7339-96c2-497a13e748bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhTxRNyhOAYcRA0vWlVcDj6s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d5e58714-3885-429b-a36a-b279a9dff2e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Amarillo College West Campus",
      "poi_type": "Education",
      "poi_address": "6222 SW 9th Ave, Amarillo, TX 79106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-18ac-71aa-88ea-59803bffc724.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-18ac-71aa-88ea-59803bffc724",
        "storage_key": "property/6767906449165615/019cfb44-18ac-71aa-88ea-59803bffc724.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.actx.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7615385847900468607&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amarillo-college-west-campus",
      "poi_latitude": "35.2068369",
      "poi_longitude": "-101.9072632",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 806-371-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b0d-7339-96c2-497a13e748bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b0d-7339-96c2-497a13e748bf",
        "storage_key": "property/6767906449165615/019cfb44-2b0d-7339-96c2-497a13e748bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTxkyGsZRAYcRf_WkoxRJr2k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_64f0566c-f5cd-4cfb-aa26-538e2e7b71b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Don Harrington Discovery Center",
      "poi_type": "Entertainment",
      "poi_address": "1200 Streit Dr, Amarillo, TX 79106, USA",
      "poi_short_description": "Children's venue offering exhibits and a theater showcasing space shows and other films.",
      "poi_long_description": "Permanent exhibits on the universe & weather, plus a theater & visiting shows for toddlers to teens.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-194a-769f-bce0-fbeb453d2a7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-194a-769f-bce0-fbeb453d2a7e",
        "storage_key": "property/6767906449165615/019cfb44-194a-769f-bce0-fbeb453d2a7e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://discoverycenteramarillo.org/?utm_source=google-gmb-maps&utm_medium=gmb-website-button&utm_campaign=locl.io&utm_content=551b89ca-129c-4559-8dfb-452b2909f411",
      "poi_directions_map_url": "https://maps.google.com/?cid=13217897852746957318&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "don-harrington-discovery-center",
      "poi_latitude": "35.2000385",
      "poi_longitude": "-101.9132754",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 806-355-9547",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b64-74bc-a56e-fb704a828570.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b64-74bc-a56e-fb704a828570",
        "storage_key": "property/6767906449165615/019cfb44-2b64-74bc-a56e-fb704a828570.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJtwVFCrZRAYcRBoJhzhBob7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_55358987-1bb6-46e1-a1a3-09a36623fcad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Bill's Backyard Classics",
      "poi_type": "Entertainment",
      "poi_address": "5309 S Washington St, Amarillo, TX 79110, USA",
      "poi_short_description": "Private, 30's-50's collection of over 100 vintage vehicles ranging from Model Ts to muscle cars, plus hot rods.",
      "poi_long_description": "People say this museum has an incredible collection of classic cars, lovingly restored and maintained in excellent condition. They highlight the vehicles are driveable and the tour guides are knowledgeable and engaging. They also like the personal tours and the informative walk-throughs of the cars and the history of the collection.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-194b-7518-9b8f-37fc90cd0f9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-194b-7518-9b8f-37fc90cd0f9d",
        "storage_key": "property/6767906449165615/019cfb44-194b-7518-9b8f-37fc90cd0f9d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.billsbackyardclassics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8333570560278974626&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bills-backyard-classics",
      "poi_latitude": "35.154351",
      "poi_longitude": "-101.8477999",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 806-373-8194",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b64-74bc-a56e-fb704a828570.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b64-74bc-a56e-fb704a828570",
        "storage_key": "property/6767906449165615/019cfb44-2b64-74bc-a56e-fb704a828570.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJY0Rzl35FAYcRotAUfEXKpnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_1add175c-b9c5-41be-a3f5-f44f17c35729",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "7701 I-40 700, Amarillo, TX 79121, USA",
      "poi_short_description": "Indoor trampoline park providing obstacle courses, a climbing wall, a zipline and more.",
      "poi_long_description": "People say this amusement park offers a variety of activities, including trampolines, a zipline, and obstacle courses, suitable for all ages. They highlight the fun and playful atmosphere, and the good value, especially with a membership. They also like the helpful, friendly, and patient staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-194a-769f-bce0-f5727d1522b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-194a-769f-bce0-f5727d1522b5",
        "storage_key": "property/6767906449165615/019cfb44-194a-769f-bce0-f5727d1522b5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.urbanair.com/texas-amarillo/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=17183422137472855803&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "35.183417",
      "poi_longitude": "-101.9299011",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 806-310-9302",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b5a-7211-b182-327f5ca447ad",
        "storage_key": "property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe2NezVRRAYcR-y6ncWTHd-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_69364e3e-5f3f-465a-9770-cb4887e3fe68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Amarillo Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "2200 S Van Buren St, Amarillo, TX 79109, USA",
      "poi_short_description": "Art museum featuring a permanent collection of Asian pieces plus temporary shows.",
      "poi_long_description": "Regional 20th-century art, including 4 Georgia O'Keeffe watercolors, plus a Pan-Asian collection.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-1977-7499-bfb6-e464fce00584.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-1977-7499-bfb6-e464fce00584",
        "storage_key": "property/6767906449165615/019cfb44-1977-7499-bfb6-e464fce00584.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.amoa.org/?utm_source=google-gmb-maps&utm_medium=gmb-website-button&utm_campaign=locl.io&utm_content=216dd4bc-81fb-4580-9828-ab80d0de8de8",
      "poi_directions_map_url": "https://maps.google.com/?cid=15566548492245588692&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amarillo-museum-of-art",
      "poi_latitude": "35.1885361",
      "poi_longitude": "-101.8451167",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 806-371-5050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b64-74bc-a56e-fb704a828570.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b64-74bc-a56e-fb704a828570",
        "storage_key": "property/6767906449165615/019cfb44-2b64-74bc-a56e-fb704a828570.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7ehFk6dPAYcR1Now62B9B9g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_3b84769f-79a0-4cf0-b5d2-0b083fc1a897",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Santa Fe Building",
      "poi_type": "Entertainment",
      "poi_address": "900 S Polk St, Amarillo, TX 79101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-1957-7643-b0a9-1cbb2198cc8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-1957-7643-b0a9-1cbb2198cc8b",
        "storage_key": "property/6767906449165615/019cfb44-1957-7643-b0a9-1cbb2198cc8b.webp",
        "width": 963,
        "height": 1280
      },
      "poi_business_url": "https://downtowntx.org/amarillo-texas/900-s-polk-st-amarillo-tx-79101",
      "poi_directions_map_url": "https://maps.google.com/?cid=14478036840879764717&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "santa-fe-building",
      "poi_latitude": "35.204334",
      "poi_longitude": "-101.838079",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 806-342-2602",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b5a-7211-b182-327f5ca447ad",
        "storage_key": "property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__8Pef5OAYcR7TSogcxR7Mg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_a8d368bc-a971-4d6c-848e-c947957b21fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3801 Olsen Blvd, Amarillo, TX 79109, USA",
      "poi_short_description": "Clean 24/7 gym featuring treadmills, plus massage chairs and tanning beds.",
      "poi_long_description": "People say this gym is clean and not overly crowded. They also highlight the friendly staff and the recent remodel.\n\nOther reviews mention the changing areas can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-196a-71f2-85f9-9d8a2205efb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-196a-71f2-85f9-9d8a2205efb0",
        "storage_key": "property/6767906449165615/019cfb44-196a-71f2-85f9-9d8a2205efb0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/amarillo-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=1977894688478342336&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.1847141",
      "poi_longitude": "-101.8828415",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 806-358-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b5a-7211-b182-327f5ca447ad",
        "storage_key": "property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyaJ0MNpPAYcRwCziZb3kchs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_91cb9382-fccd-4fdf-a576-14569ffd3a0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Crunch Fitness - Amarillo",
      "poi_type": "Health and Wellness",
      "poi_address": "2020 S Georgia St, Amarillo, TX 79109, USA",
      "poi_short_description": "Chain fitness center offering group classes and personal training, plus tanning and a daycare.",
      "poi_long_description": "People say this gym offers a wide selection of equipment, including assisted weights, free weights, and plate-loaded machines. They also highlight the friendly and helpful staff, and the clean facilities.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-19b9-708c-a77a-e6491a6c2686.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-19b9-708c-a77a-e6491a6c2686",
        "storage_key": "property/6767906449165615/019cfb44-19b9-708c-a77a-e6491a6c2686.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.crunch.com/locations/amarillo",
      "poi_directions_map_url": "https://maps.google.com/?cid=5337674825006290011&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---amarillo",
      "poi_latitude": "35.1919693",
      "poi_longitude": "-101.867029",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 806-358-0706",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b5a-7211-b182-327f5ca447ad",
        "storage_key": "property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ429cxMlPAYcRW5QLH_k6E0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7cb62d55-3a0c-4ed5-99c4-f8914d427c60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "TruFit Athletic Clubs - I40/Bell St.",
      "poi_type": "Health and Wellness",
      "poi_address": "2200 Bell St, Amarillo, TX 79106, USA",
      "poi_short_description": "Gym chain featuring premium facilities such as basketball courts and saunas, plus personal trainers.",
      "poi_long_description": "Gym goers say this gym has a wide variety of equipment, including free weights, pin machines, plate loaded machines, smith machines, and treadmills, as well as a women’s only area and a sauna. They also highlight the friendly and helpful staff, the clean environment, and the spacious layout.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-1b28-73e9-aa31-aa55e36076c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-1b28-73e9-aa31-aa55e36076c4",
        "storage_key": "property/6767906449165615/019cfb44-1b28-73e9-aa31-aa55e36076c4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://trufitathleticclubs.com/gym-near-me/tru-fit-texas/amarillo/hwy-40-bell-st/&utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=17282652066854458207&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trufit-athletic-clubs---i40bell-st",
      "poi_latitude": "35.1889247",
      "poi_longitude": "-101.9037135",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 806-803-2302",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b5a-7211-b182-327f5ca447ad",
        "storage_key": "property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgUXZW6JRAYcRX9OHxXxQ2O8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_001f6a97-5e05-4204-9092-2cf96ac6033a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "2814 S Soncy Rd, Amarillo, TX 79124, USA",
      "poi_short_description": "Large chain selling cosmetics, skincare and fragrance, plus hair salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-202e-769e-a1f5-d59913e870cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-202e-769e-a1f5-d59913e870cf",
        "storage_key": "property/6767906449165615/019cfb44-202e-769e-a1f5-d59913e870cf.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/amarillo-tx-278",
      "poi_directions_map_url": "https://maps.google.com/?cid=6046894659973430930&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "35.1814406",
      "poi_longitude": "-101.9399397",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 806-355-1176",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b5a-7211-b182-327f5ca447ad",
        "storage_key": "property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf8ncs_lQAYcRkj7syafi6lM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_39bcc1e4-9b84-4716-b43e-be38f600647e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Amarillo Town Club",
      "poi_type": "Health and Wellness",
      "poi_address": "5801, 4514 Cornell St A, Amarillo, TX 79109, USA",
      "poi_short_description": "Health club offering a variety of equipment and classes, along with indoor and outdoor pools.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2035-7059-850f-066e8a46917f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-2035-7059-850f-066e8a46917f",
        "storage_key": "property/6767906449165615/019cfb44-2035-7059-850f-066e8a46917f.webp",
        "width": 1200,
        "height": 688
      },
      "poi_business_url": "https://amarillotownclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16997861687070698109&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amarillo-town-club",
      "poi_latitude": "35.16022100000001",
      "poi_longitude": "-101.89843",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 806-468-0398",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b5a-7211-b182-327f5ca447ad",
        "storage_key": "property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjT76sAVQAYcRfSoSVyWJ5Os",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_49148769-6fe9-4d18-8875-2e3ca03470ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "P.E.T.S. Clinic of Amarillo",
      "poi_type": "Health and Wellness",
      "poi_address": "2500 SW 6th Ave, Amarillo, TX 79106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-207c-75fb-ac37-68c4a8243172.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-207c-75fb-ac37-68c4a8243172",
        "storage_key": "property/6767906449165615/019cfb44-207c-75fb-ac37-68c4a8243172.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.petsclinic.org/locations/amarillo-texas/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1242055613026336119&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pets-clinic-of-amarillo",
      "poi_latitude": "35.2117343",
      "poi_longitude": "-101.8647921",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 806-680-7049",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b5a-7211-b182-327f5ca447ad",
        "storage_key": "property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJyRWFUtPAYcRd_221f-qPBE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_80cc940e-fe2c-4bef-ad9b-c2a512b10972",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Bnails Amarillo ( Voted Best Nail Salon Amarillo TX)",
      "poi_type": "Health and Wellness",
      "poi_address": "5901 Coulter St S #200, Amarillo, TX 79119, USA",
      "poi_short_description": "Modern nail salon offering a variety of treatments including pedicures.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2079-75ab-ab67-e64a2967075b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-2079-75ab-ab67-e64a2967075b",
        "storage_key": "property/6767906449165615/019cfb44-2079-75ab-ab67-e64a2967075b.webp",
        "width": 1050,
        "height": 1050
      },
      "poi_business_url": "https://bnails.com/locations/bnails-amarillo",
      "poi_directions_map_url": "https://maps.google.com/?cid=2463208448936350150&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bnails-amarillo--voted-best-nail-salon-amarillo-tx",
      "poi_latitude": "35.1476278",
      "poi_longitude": "-101.9194274",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 806-329-0101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b5a-7211-b182-327f5ca447ad",
        "storage_key": "property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkbhOxQdbAYcRxpGXnggTLyI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_d4de70d2-87a2-40bf-bcd0-b557ba9b0747",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "The Gym @ Contagion Athletics",
      "poi_type": "Health and Wellness",
      "poi_address": "8210 W Amarillo Blvd Suite A, Amarillo, TX 79124, USA",
      "poi_short_description": "Clean gym with modern equipment, turf, private rooms, a cafe, and friendly staff.",
      "poi_long_description": "People say this gym offers a wide variety of high-quality equipment, including machines, free weights, and power racks, as well as a track and field. They highlight the spacious layout, motivating atmosphere, and clean facilities. They also like the friendly, supportive, and accommodating staff. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-21f2-72c1-8b76-1a0c3854909c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-21f2-72c1-8b76-1a0c3854909c",
        "storage_key": "property/6767906449165615/019cfb44-21f2-72c1-8b76-1a0c3854909c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://contagionathletics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1028127880143985371&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-gym--contagion-athletics",
      "poi_latitude": "35.1921768",
      "poi_longitude": "-101.9283828",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 806-599-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b5a-7211-b182-327f5ca447ad",
        "storage_key": "property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIVPdCchaAYcR21qoF9ykRA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_71548e1c-7ad2-4e74-9f22-b735919b9f23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4514 First United Dr, Amarillo, TX 79119, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-223b-7211-98d9-be034adee514.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-223b-7211-98d9-be034adee514",
        "storage_key": "property/6767906449165615/019cfb44-223b-7211-98d9-be034adee514.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/amarillo-texas-4451/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=4451",
      "poi_directions_map_url": "https://maps.google.com/?cid=4329623978590993559&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "35.1605005",
      "poi_longitude": "-101.9368164",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 806-367-9842",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b5a-7211-b182-327f5ca447ad",
        "storage_key": "property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkwTg_UNRAYcRl_ztthHqFTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_54dab20f-522d-427a-8210-d1a017a80c1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Small Animal Emergency Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "5127 Canyon Dr, Amarillo, TX 79110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-21c1-72be-a8a9-8b2849835df1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-21c1-72be-a8a9-8b2849835df1",
        "storage_key": "property/6767906449165615/019cfb44-21c1-72be-a8a9-8b2849835df1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.smallanimalec.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3409723369463033888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "small-animal-emergency-clinic",
      "poi_latitude": "35.156026",
      "poi_longitude": "-101.877585",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 806-352-2277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b5a-7211-b182-327f5ca447ad",
        "storage_key": "property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZQR8CU5FAYcRIDAxy1bFUS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_5a5d125c-8fb1-4695-afda-d25c4999925a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "BSA Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1600 Wallace Blvd, Amarillo, TX 79106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-223b-7211-98d9-b80ddbd32bf5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-223b-7211-98d9-b80ddbd32bf5",
        "storage_key": "property/6767906449165615/019cfb44-223b-7211-98d9-b80ddbd32bf5.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://bsahs.org/find-a-provider/location/entity69860/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8155463932870903813&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bsa-hospital",
      "poi_latitude": "35.19633",
      "poi_longitude": "-101.9203683",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 806-212-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b66-746b-b63e-245456b96e67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b66-746b-b63e-245456b96e67",
        "storage_key": "property/6767906449165615/019cfb44-2b66-746b-b63e-245456b96e67.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJj-hXBuxRAYcRBchHyTwHLnE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_71f901fc-95e2-46df-96e6-812278b5212c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Northwest Texas Healthcare System",
      "poi_type": "Health and Wellness",
      "poi_address": "1501 Coulter St, Amarillo, TX 79106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-207c-75fb-ac37-6e77589ce042.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-207c-75fb-ac37-6e77589ce042",
        "storage_key": "property/6767906449165615/019cfb44-207c-75fb-ac37-6e77589ce042.webp",
        "width": 724,
        "height": 407
      },
      "poi_business_url": "https://www.nwths.com/?utm_source=Google-Business-Yext&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=2075520162708353978&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "northwest-texas-healthcare-system",
      "poi_latitude": "35.1998268",
      "poi_longitude": "-101.9201891",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 806-354-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b66-746b-b63e-245456b96e67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b66-746b-b63e-245456b96e67",
        "storage_key": "property/6767906449165615/019cfb44-2b66-746b-b63e-245456b96e67.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJO08CY7FRAYcRunNkZpe6zRw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_e2cbcd07-3c07-4cab-b159-d3e2fca949bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Amarillo Botanical Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1400 Streit Dr, Amarillo, TX 79106, USA",
      "poi_short_description": "Small but well-maintained botanical garden featuring a Japanese area, a conservatory and a rose garden.",
      "poi_long_description": "People say this botanical garden offers a beautiful variety of plants, flowers, and themed gardens, including a butterfly garden, desert garden, rose garden, and Japanese garden. They highlight the peaceful and relaxing atmosphere, perfect for enjoying nature and taking photos, and the well-maintained grounds with easy-to-navigate walking paths. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2203-746c-ba98-6878a6d1ab6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-2203-746c-ba98-6878a6d1ab6d",
        "storage_key": "property/6767906449165615/019cfb44-2203-746c-ba98-6878a6d1ab6d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.amarillobotanicalgardens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11051265959285629208&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amarillo-botanical-gardens",
      "poi_latitude": "35.197691",
      "poi_longitude": "-101.915258",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 806-352-6513",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b58-7047-b974-e6728c347a52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b58-7047-b974-e6728c347a52",
        "storage_key": "property/6767906449165615/019cfb44-2b58-7047-b974-e6728c347a52.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVYUtV7RRAYcRGCGWfdb7XZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_324df922-5c37-4f8d-b883-5b6f62436b22",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "John Stiff Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4800 Bell St, Amarillo, TX 79109, USA",
      "poi_short_description": "Large open space, mainly for organized sports, featuring soccer and baseball fields.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-249c-7435-9c7b-75858c669ca2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-249c-7435-9c7b-75858c669ca2",
        "storage_key": "property/6767906449165615/019cfb44-249c-7435-9c7b-75858c669ca2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.amarilloparks.org/parks-facilities/parks/john-stiff-memorial-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14142316035318156834&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "john-stiff-memorial-park",
      "poi_latitude": "35.1534565",
      "poi_longitude": "-101.9061596",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 806-378-3036",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b58-7047-b974-e6728c347a52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b58-7047-b974-e6728c347a52",
        "storage_key": "property/6767906449165615/019cfb44-2b58-7047-b974-e6728c347a52.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ5FNyghQAYcRIg5zQoGZQ8Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_df8608cc-1f8c-406e-85ad-477a64f7e027",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Wildcat Bluff Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2301 N Soncy Rd, Amarillo, TX 79124, USA",
      "poi_short_description": "Preserve with miles of hiking trails and historical exhibits including a dig pit, plus picnic areas.",
      "poi_long_description": "Visitors say this nature preserve offers several easy hiking trails, a large playground, and a wildlife center with local animals. They also highlight the beautiful wildflowers, diverse terrain, and well-maintained trails, making it a great spot for families with kids and grandparents.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2490-72ea-b8a7-e43a1f3015a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-2490-72ea-b8a7-e43a1f3015a9",
        "storage_key": "property/6767906449165615/019cfb44-2490-72ea-b8a7-e43a1f3015a9.webp",
        "width": 1125,
        "height": 633
      },
      "poi_business_url": "http://wildcatbluff.org/?utm_source=google-gmb-maps&utm_medium=gmb-website-button&utm_campaign=locl.io&utm_content=ff955b2f-0847-4125-bf3c-98fd107de872",
      "poi_directions_map_url": "https://maps.google.com/?cid=1448519830726704444&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wildcat-bluff-nature-center",
      "poi_latitude": "35.2351151",
      "poi_longitude": "-101.9398872",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 15 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 806-352-6007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b58-7047-b974-e6728c347a52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b58-7047-b974-e6728c347a52",
        "storage_key": "property/6767906449165615/019cfb44-2b58-7047-b974-e6728c347a52.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJnY_PHH5RAYcRPP2SiBwtGhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6b0a19c9-b8d3-422f-ba80-0efb3475756a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2501 S Washington St, Amarillo, TX 79109, USA",
      "poi_short_description": "Rose-filled park featuring playground equipment, basketball courts, tennis courts and a splash pad.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-24bf-71ec-a3fe-bc481540f826.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-24bf-71ec-a3fe-bc481540f826",
        "storage_key": "property/6767906449165615/019cfb44-24bf-71ec-a3fe-bc481540f826.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://amarilloparks.org/parks-facilities/parks/memorial-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6032325091350410499&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "memorial-park",
      "poi_latitude": "35.1856121",
      "poi_longitude": "-101.8473415",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 806-378-3036",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b58-7047-b974-e6728c347a52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b58-7047-b974-e6728c347a52",
        "storage_key": "property/6767906449165615/019cfb44-2b58-7047-b974-e6728c347a52.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJDT5IzKZPAYcRA_Wdv7Uft1M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0438f119-e624-4376-938e-084710947b33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Medical Center Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1100 Wallace Blvd, Amarillo, TX 79106, USA",
      "poi_short_description": "Tranquil waterside park, featuring a walking trail and botanical gardens. Picnic tables also available, along with grills and playgrounds, plus a splash pad for kids.",
      "poi_long_description": "People say this park offers a splash pad, walking trails, basketball court, lake, trees, picnic tables, and a playground. They highlight the park is a nice place to visit for a walk and to play with children, and that it's enjoyable for people of all ages. They also like the fishing opportunities and bird watching. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-250c-73d1-9086-a0a7b18df615.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-250c-73d1-9086-a0a7b18df615",
        "storage_key": "property/6767906449165615/019cfb44-250c-73d1-9086-a0a7b18df615.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://amarilloparks.org/parks-facilities/parks/medical-center-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9095130730762279602&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "medical-center-park",
      "poi_latitude": "35.2009597",
      "poi_longitude": "-101.9136857",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 806-378-3036",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b58-7047-b974-e6728c347a52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b58-7047-b974-e6728c347a52",
        "storage_key": "property/6767906449165615/019cfb44-2b58-7047-b974-e6728c347a52.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKzHNYLZRAYcRshrTKDZlOH4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5a57201b-16cb-4128-b14a-5aecea34d5f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Tradewind Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "4105 Tradewind St, Amarillo, TX 79118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-254b-713c-aa1e-482044f7e9a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-254b-713c-aa1e-482044f7e9a3",
        "storage_key": "property/6767906449165615/019cfb44-254b-713c-aa1e-482044f7e9a3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tradewindairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15990282243124226512&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tradewind-airport",
      "poi_latitude": "35.168991",
      "poi_longitude": "-101.828453",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 806-376-1008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b53-7125-ab4b-e69a86f01445.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b53-7125-ab4b-e69a86f01445",
        "storage_key": "property/6767906449165615/019cfb44-2b53-7125-ab4b-e69a86f01445.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-yXpyPFOAYcR0Omn3_rk6N0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_28fa7614-60b0-4292-b0fd-c6fbec4856a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Panhandle Eye Group Corporate Business Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7400 Fleming Ave, Amarillo, TX 79106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2689-7564-86b5-751fe4f34015.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-2689-7564-86b5-751fe4f34015",
        "storage_key": "property/6767906449165615/019cfb44-2689-7564-86b5-751fe4f34015.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.paneye.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6239967148491259387&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "panhandle-eye-group-corporate-business-office",
      "poi_latitude": "35.1935734",
      "poi_longitude": "-101.9237593",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 806-331-4444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b5a-7211-b182-327f5ca447ad",
        "storage_key": "property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKcUlU61RAYcR-73tjw_RmFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_17dbd677-8836-49e3-b0a5-acb405c4fa0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Toot'n Totum Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1201 S Taylor St, Amarillo, TX 79101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.tootntotum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9938605481419247298&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tootn-totum-corporate-office",
      "poi_latitude": "35.2019996",
      "poi_longitude": "-101.8364486",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 806-373-4351",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b5a-7211-b182-327f5ca447ad",
        "storage_key": "property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyWigFwJPAYcRwo6-QgcF7Yk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_9293c168-bfc9-47e7-af90-2ccb2ec865f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Downtown Women's Center - Admin Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "409 S Monroe St, Amarillo, TX 79101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.dwcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17471674227271005040&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "downtown-womens-center---admin-office",
      "poi_latitude": "35.2100297",
      "poi_longitude": "-101.8426996",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 806-372-3625",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b5a-7211-b182-327f5ca447ad",
        "storage_key": "property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz-D7mlVOAYcRcPPVCyTbd_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_fc40f8af-66d7-49c1-af63-b508b4253997",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Panhandle AIDS Support Organization",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1501 SW 10th Ave, Amarillo, TX 79101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-26d8-76ce-8244-e41f599d9ca4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-26d8-76ce-8244-e41f599d9ca4",
        "storage_key": "property/6767906449165615/019cfb44-26d8-76ce-8244-e41f599d9ca4.webp",
        "width": 1280,
        "height": 892
      },
      "poi_business_url": "http://panhandleaso.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7593567755602905026&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "panhandle-aids-support-organization",
      "poi_latitude": "35.2048277",
      "poi_longitude": "-101.8548318",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 806-372-1050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b5a-7211-b182-327f5ca447ad",
        "storage_key": "property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcxRxZalPAYcRwkeSKqTFYWk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_d119f8a3-3a23-4034-8f1b-8cf0bc032c9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Full Smile Management",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2201 Civic Cir Suite 600, Amarillo, TX 79109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.fullsmilemanagement.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9167356463195991801&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "full-smile-management",
      "poi_latitude": "35.1906971",
      "poi_longitude": "-101.8643049",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 806-381-3435",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b5a-7211-b182-327f5ca447ad",
        "storage_key": "property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlVO_ZDdRAYcR-a4t7iH-OH8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4c49fd15-29b7-4675-9a4c-976753c9920d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Ascension Academy",
      "poi_type": "Education",
      "poi_address": "9301 Ascension Pkwy, Amarillo, TX 79119, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d7912-b6bf-70d9-ad1a-ac81622b35c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-b6bf-70d9-ad1a-ac81622b35c4",
        "storage_key": "property/6767906449165615/019d7912-b6bf-70d9-ad1a-ac81622b35c4.webp",
        "width": 332,
        "height": 352
      },
      "poi_business_url": "http://www.ascensionacademy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12001972514699204040&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ascension-academy",
      "poi_latitude": "35.1575853",
      "poi_longitude": "-101.9461933",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 806-342-0515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b0d-7339-96c2-497a13e748bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b0d-7339-96c2-497a13e748bf",
        "storage_key": "property/6767906449165615/019cfb44-2b0d-7339-96c2-497a13e748bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdeF9CJBQAYcRyNWltmmSj6Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_c8bf374f-d2ce-472c-b57a-19e6fb879790",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Amarillo Collegiate Academy",
      "poi_type": "Education",
      "poi_address": "6000 S Georgia St, Amarillo, TX 79118, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d7912-b6b6-760e-89d6-e7f36fba5d52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-b6b6-760e-89d6-e7f36fba5d52",
        "storage_key": "property/6767906449165615/019d7912-b6b6-760e-89d6-e7f36fba5d52.webp",
        "width": 441,
        "height": 331
      },
      "poi_business_url": "https://questcollegiate.com/amarillo/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13263260898786172110&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amarillo-collegiate-academy",
      "poi_latitude": "35.1473",
      "poi_longitude": "-101.8671534",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 806-352-0171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b0d-7339-96c2-497a13e748bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b0d-7339-96c2-497a13e748bf",
        "storage_key": "property/6767906449165615/019cfb44-2b0d-7339-96c2-497a13e748bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzW3Gi2dFAYcRzlx6A4SRELg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_c880725e-6896-42d0-8d47-fabeae86d772",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Amarillo High School",
      "poi_type": "Education",
      "poi_address": "4225 Danbury Dr, Amarillo, TX 79109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d7912-b700-77fe-8008-c247033e44c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-b700-77fe-8008-c247033e44c7",
        "storage_key": "property/6767906449165615/019d7912-b700-77fe-8008-c247033e44c7.webp",
        "width": 622,
        "height": 1280
      },
      "poi_business_url": "https://ahs.amaisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=752823074420987254&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amarillo-high-school",
      "poi_latitude": "35.16616339999999",
      "poi_longitude": "-101.9050351",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 806-326-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b0d-7339-96c2-497a13e748bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b0d-7339-96c2-497a13e748bf",
        "storage_key": "property/6767906449165615/019cfb44-2b0d-7339-96c2-497a13e748bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq4aKDhFQAYcRdpWU-ZiQcgo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_55e04f86-c01c-4ed0-8854-bb986864bfc6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Bonham Middle School",
      "poi_type": "Education",
      "poi_address": "5600 SW 49th Ave, Amarillo, TX 79109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d7912-b98f-7281-99b9-81280c4724d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-b98f-7281-99b9-81280c4724d1",
        "storage_key": "property/6767906449165615/019d7912-b98f-7281-99b9-81280c4724d1.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://bonham.amaisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3883294758665483965&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bonham-middle-school",
      "poi_latitude": "35.15732089999999",
      "poi_longitude": "-101.8961833",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 806-326-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b0d-7339-96c2-497a13e748bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b0d-7339-96c2-497a13e748bf",
        "storage_key": "property/6767906449165615/019cfb44-2b0d-7339-96c2-497a13e748bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJyVkNvQZQAYcRvXZkKAI85DU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_03bdefcf-1165-457e-810b-311bc1104b45",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Sleepy Hollow Elementary School",
      "poi_type": "Education",
      "poi_address": "3435 Reeder Dr, Amarillo, TX 79121, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.amaisd.org/sh",
      "poi_directions_map_url": "https://maps.google.com/?cid=15639881902399074499&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sleepy-hollow-elementary-school",
      "poi_latitude": "35.1742085",
      "poi_longitude": "-101.9344811",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 806-326-5301",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b0d-7339-96c2-497a13e748bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b0d-7339-96c2-497a13e748bf",
        "storage_key": "property/6767906449165615/019cfb44-2b0d-7339-96c2-497a13e748bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ48DAcV9QAYcRw7COAboFDNk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_942dc999-74bc-4b2f-9e08-69e5153eaa4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Texas Tech University at Amarillo",
      "poi_type": "Education",
      "poi_address": "1400 Coulter St S, Amarillo, TX 79106, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.ttuhsc.edu/campus/amarillo/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3594923258626868166&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "texas-tech-university-at-amarillo",
      "poi_latitude": "35.2004197",
      "poi_longitude": "-101.9236083",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 806-414-9608",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b0d-7339-96c2-497a13e748bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b0d-7339-96c2-497a13e748bf",
        "storage_key": "property/6767906449165615/019cfb44-2b0d-7339-96c2-497a13e748bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2VTQIa5RAYcRxoM-Mai74zE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_bc02639a-8823-4a7c-8d78-fe4bcc31ddf2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Cask & Cork",
      "poi_type": "Restaurants",
      "poi_address": "5461 McKenna Square Unit 101, Amarillo, TX 79119, USA",
      "poi_short_description": "Upmarket eatery featuring steaks and burgers along with an upstairs bar and an outdoor patio.",
      "poi_long_description": "People say this restaurant serves delicious food, including grilled chicken, burgers, and steak. They highlight the unbeatable atmosphere, especially on the rooftop bar, and the friendly service. They also like the extensive drink menu, featuring cocktails and wine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d7912-c1ea-7260-8504-cb0c7ede2eb9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c1ea-7260-8504-cb0c7ede2eb9",
        "storage_key": "property/6767906449165615/019d7912-c1ea-7260-8504-cb0c7ede2eb9.webp",
        "width": 1280,
        "height": 718
      },
      "poi_business_url": "http://caskncorkamarillo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3520810096458604600&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cask-cork",
      "poi_latitude": "35.1521866",
      "poi_longitude": "-101.9423172",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 806-410-1113",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b68-75f8-9e36-f941bb6273d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b68-75f8-9e36-f941bb6273d1",
        "storage_key": "property/6767906449165615/019cfb44-2b68-75f8-9e36-f941bb6273d1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5bHHsoNQAYcROCAG8SBu3DA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_5dbcd8e0-a59a-4a54-bd5c-daf38f33e8e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Public House",
      "poi_type": "Restaurants",
      "poi_address": "3333 Coulter St S, Amarillo, TX 79106, USA",
      "poi_short_description": "Stylish, modern American spot for elevated comfort food along with cocktails, wine & craft beer.",
      "poi_long_description": "People say this restaurant serves delicious meatloaf, prime rib soup, and wedge salad. They also highlight the inviting atmosphere, friendly and courteous service, and great drinks.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d7912-bca5-76b0-af41-4b8926ba6b89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-bca5-76b0-af41-4b8926ba6b89",
        "storage_key": "property/6767906449165615/019d7912-bca5-76b0-af41-4b8926ba6b89.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "http://www.publichouseamarillo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1105803344453180030&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "public-house",
      "poi_latitude": "35.1772076",
      "poi_longitude": "-101.9197562",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 806-398-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b68-75f8-9e36-f941bb6273d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b68-75f8-9e36-f941bb6273d1",
        "storage_key": "property/6767906449165615/019cfb44-2b68-75f8-9e36-f941bb6273d1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJA-IFd0RQAYcRfhqScUiaWA8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_0ee455ad-3d2c-490d-a5e3-464d7bb9e049",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Texas Kitchen inside market street",
      "poi_type": "Restaurants",
      "poi_address": "2530 S Georgia St, Amarillo, TX 79109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d7912-c078-7319-91df-e0e00087e2c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c078-7319-91df-e0e00087e2c5",
        "storage_key": "property/6767906449165615/019d7912-c078-7319-91df-e0e00087e2c5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=219121547153894294&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "texas-kitchen-inside-market-street",
      "poi_latitude": "35.185986",
      "poi_longitude": "-101.8678502",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b68-75f8-9e36-f941bb6273d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b68-75f8-9e36-f941bb6273d1",
        "storage_key": "property/6767906449165615/019cfb44-2b68-75f8-9e36-f941bb6273d1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAbPvvZNPAYcRluu93OJ5CgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_a6209519-c37a-4de2-8122-17388a6e93e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Chili's Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "5016 Coulter St S, Amarillo, TX 79119, USA",
      "poi_short_description": "Family-friendly chain serving classic Tex-Mex & American fare in a Southwestern-style setting.",
      "poi_long_description": "People say this restaurant offers delicious burgers, fajitas, and other comfort food, and provides a relaxed atmosphere.\n\nOther reviews mention the food can be bland and the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d7912-c1e8-77fa-bfe5-d231d32c388a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c1e8-77fa-bfe5-d231d32c388a",
        "storage_key": "property/6767906449165615/019d7912-c1e8-77fa-bfe5-d231d32c388a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chilis.com/locations/us/texas/amarillo/south-amarillo?utm_source=google&utm_medium=local&utm_campaign=Chilis",
      "poi_directions_map_url": "https://maps.google.com/?cid=18322782272590554769&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chili-s-grill-bar",
      "poi_latitude": "35.155736",
      "poi_longitude": "-101.920729",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 806-353-2992",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b68-75f8-9e36-f941bb6273d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b68-75f8-9e36-f941bb6273d1",
        "storage_key": "property/6767906449165615/019cfb44-2b68-75f8-9e36-f941bb6273d1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ22ayK3dQAYcRkaaVDmaZR_4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_33f065ef-7fc9-4af7-99a2-76605abae9ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Teddy Jack's Armadillo Grill",
      "poi_type": "Restaurants",
      "poi_address": "5080 Coulter St S, Amarillo, TX 79119, USA",
      "poi_short_description": "Family-friendly grill serving burgers and Tex-Mex fare, along with beer and cocktails.",
      "poi_long_description": "People say this restaurant offers a wide variety of dishes, including pizza, salads, and burgers. They also highlight the great service and friendly staff.\n\nOther reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d7912-c673-74ba-914d-8717bed86478.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c673-74ba-914d-8717bed86478",
        "storage_key": "property/6767906449165615/019d7912-c673-74ba-914d-8717bed86478.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://teddyjacks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5472714489992181899&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "teddy-jack-s-armadillo-grill",
      "poi_latitude": "35.1540453",
      "poi_longitude": "-101.9207991",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 806-322-0113",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b68-75f8-9e36-f941bb6273d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b68-75f8-9e36-f941bb6273d1",
        "storage_key": "property/6767906449165615/019cfb44-2b68-75f8-9e36-f941bb6273d1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYW9a-XZQAYcRi_gdPdX88ks",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_cbddc20a-ad40-47f0-afce-4e9d1286a68a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Amarillo Zoo",
      "poi_type": "Entertainment",
      "poi_address": "700 Comanchero Trail, Amarillo, TX 79107, USA",
      "poi_short_description": "Bison & big cats, reptiles, birds & amphibians all can be found in this compact park.",
      "poi_long_description": "People say this zoo offers a variety of animals, including exotic creatures, and is a fun and affordable experience for families.\n\nOther reviews mention the facilities can be neglected and some enclosures can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d7912-d28f-75db-8aad-7038cb388cb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-d28f-75db-8aad-7038cb388cb5",
        "storage_key": "property/6767906449165615/019d7912-d28f-75db-8aad-7038cb388cb5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://zoo.amarillo.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7520201244900869847&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amarillo-zoo",
      "poi_latitude": "35.2394971",
      "poi_longitude": "-101.8352622",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 806-381-7911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b5a-7211-b182-327f5ca447ad",
        "storage_key": "property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy-PYbYVOAYcR10bEQTAfXWg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_4871f636-6aba-4567-899f-f6322c7e2f86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Cadillac Ranch",
      "poi_type": "Entertainment",
      "poi_address": "13651 I-40 Frontage Rd, Amarillo, TX 79124, USA",
      "poi_short_description": "Quirky public art installation featuring half-buried vintage Cadillacs covered with bright graffiti.",
      "poi_long_description": "People say this sculpture is a quirky and colorful art installation featuring painted cars. They also highlight the free entry, the opportunity to spray paint the cars, and the unique photo opportunities.\n\nSome reviews mention the trail can be muddy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d7912-dac5-744d-a7fc-d1ed352de9c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-dac5-744d-a7fc-d1ed352de9c3",
        "storage_key": "property/6767906449165615/019d7912-dac5-744d-a7fc-d1ed352de9c3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/1974cadillacranch/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6041817576782515537&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cadillac-ranch",
      "poi_latitude": "35.1872366",
      "poi_longitude": "-101.9870486",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 833-330-2650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b5a-7211-b182-327f5ca447ad",
        "storage_key": "property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi8Roa9ZWAYcRUU3VPRPZ2FM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sculpture"
    },
    {
      "id": "custom_9ec870c2-da1f-4dad-a3e3-a44f67a54608",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Palo Duro Canyon State Park",
      "poi_type": "Entertainment",
      "poi_address": "Canyon, TX 79015, USA",
      "poi_short_description": "Big ravine with 800-ft cliffs, multi-use trails, campsites & the musical \"Texas\" in an amphitheater.",
      "poi_long_description": "People say this state park offers stunning views of the canyon, fun hiking and biking trails, and delicious hotdogs at the outpost. They highlight the beautiful scenery, well-maintained trails, and clean restrooms. They also like the convenient amenities, such as sunscreen and water stations, and the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d7912-dba5-77ec-a821-57748f346f9c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-dba5-77ec-a821-57748f346f9c",
        "storage_key": "property/6767906449165615/019d7912-dba5-77ec-a821-57748f346f9c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tpwd.texas.gov/state-parks/palo-duro-canyon",
      "poi_directions_map_url": "https://maps.google.com/?cid=2130752817766660468&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "palo-duro-canyon-state-park",
      "poi_latitude": "34.9372503",
      "poi_longitude": "-101.6589305",
      "poi_miles_from_property": "29.7 mi",
      "poi_walking_minutes": "10 hours 39 mins",
      "poi_biking_minutes": "2 hours 28 mins",
      "poi_driving_minutes": "45 mins",
      "poi_business_phone": "+1 806-488-2227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b58-7047-b974-e6728c347a52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b58-7047-b974-e6728c347a52",
        "storage_key": "property/6767906449165615/019cfb44-2b58-7047-b974-e6728c347a52.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJsWSkAmEUAYcRdPkkB2b0kR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_e113fc92-9373-4a0f-b61f-14980fea3cf7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Wonderland Amusement Park",
      "poi_type": "Entertainment",
      "poi_address": "2601 Dumas Dr, Amarillo, TX 79107, USA",
      "poi_short_description": "Roller coasters, carousel, water & kiddie rides (some nostalgic), plus an arcade & more, since 1951.",
      "poi_long_description": "People say this amusement park offers a variety of rides and attractions, including classic coasters and flat rides, and is a fun place to spend time with family. They also highlight the friendly and helpful staff, and the nostalgic, old-school vibe.\n\nOther reviews mention some rides can be closed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d7912-d588-707f-8dbb-761c8b6ef958.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-d588-707f-8dbb-761c8b6ef958",
        "storage_key": "property/6767906449165615/019d7912-d588-707f-8dbb-761c8b6ef958.webp",
        "width": 1280,
        "height": 614
      },
      "poi_business_url": "http://www.wonderlandpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8243954437591312918&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wonderland-amusement-park",
      "poi_latitude": "35.2407215",
      "poi_longitude": "-101.8321242",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 32 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 806-383-3344",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b5a-7211-b182-327f5ca447ad",
        "storage_key": "property/6767906449165615/019cfb44-2b5a-7211-b182-327f5ca447ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdfEzUZtOAYcRFqoi9eFoaHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_995dbb63-caa0-40f3-bc24-b33486f55a00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "poi_name": "Texas Air & Space Museum",
      "poi_type": "Entertainment",
      "poi_address": "10001 American Dr, Amarillo, TX 79111, USA",
      "poi_short_description": "A variety of aerospace artifacts on display, plus several civilian & military aircraft.",
      "poi_long_description": "People say this museum offers a lot to see and learn, including several planes that visitors can explore. They highlight the knowledgeable and friendly staff, and the fun, hands-on experience. They also like the opportunity to learn the stories behind the exhibits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019d7912-e525-770a-b259-0a2b3d690871.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-e525-770a-b259-0a2b3d690871",
        "storage_key": "property/6767906449165615/019d7912-e525-770a-b259-0a2b3d690871.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.texasairandspacemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11398286253293493375&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "texas-air-space-museum",
      "poi_latitude": "35.2134157",
      "poi_longitude": "-101.7140016",
      "poi_miles_from_property": "14.6 mi",
      "poi_walking_minutes": "5 hours 26 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 806-335-9159",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-2b64-74bc-a56e-fb704a828570.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-2b64-74bc-a56e-fb704a828570",
        "storage_key": "property/6767906449165615/019cfb44-2b64-74bc-a56e-fb704a828570.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJL0uctixIAYcRf9zG5_TYLp4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    }
  ],
  "office_hours": [
    {
      "id": "ec_8744e89099b7f02779b87bcb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_a23391f5a290c2b4fdd9f463",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_1a642347199ec843955fc52f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_caf8b3570e887166fceb76eb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_026c73a2aaf8c4f5137a2760",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_e4204eee71cbf77727f5cc1a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_50b0e390-4ad5-427a-b231-b940af554264",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "rating": "5.0",
      "name": "Lauren Rypien",
      "text": "My husband has lived here for a few years and I recently moved up here this year. We absolutely love renting here. The apartment is gorgeous, spacious and we love the open-plan design of the kitchen and living spaces.\nThe management team is excellent, always friendly and helpful.\nI would especially like to give credit to Miss Kim, who works in the leasing office. I have had the pleasure of getting to know her and she brightens my day every time I see her, as well as always lending a helping hand and answering anything I need to ask her. Stefani is awesome too.\nThe communal spaces are lovely. The gym is great, and I especially love the pool and grill area.\nThe management team takes excellent care of all aspects of the complex, and you can see them working hard on something new every single day!\nI would recommend The Park at Coulter 1000 times over. Beautiful place to live!",
      "date": "2025-10-03",
      "title": ""
    },
    {
      "id": "custom_b4ee04b7-d809-4d32-890a-74df639c4d70",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "rating": "5.0",
      "name": "Ruthy Leake",
      "text": "Mike and I have been residents with Park at Coulter Apartments for seven months.   My first appreciation of our complex was safety I felt when taking my little dog out for at midnight.  Very quite and very well lit.\nThe neighborhood is pleasant and beautiful.  No noise pollution.  No running strays and etc.\nManager, office staff, maintenance, and porter are friendly and quick to respond if needed or have a problem.\nI would be glad to recommend to others.\nThanks, Ruthy",
      "date": "2025-08-20",
      "title": ""
    },
    {
      "id": "custom_cafffb0d-d0f0-4c7b-9182-b05d8da7289a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "rating": "5.0",
      "name": "Trevida Trevino",
      "text": "Great complex and great management. They are constantly moving from project to project to upkeep the grounds, and buildings keeping the property beautiful and safe. The on site personnel are competent and care about tenants.",
      "date": "2025-08-19",
      "title": ""
    },
    {
      "id": "custom_780c9a86-934e-4f07-8cc6-2c7bf8cefb46",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "rating": "5.0",
      "name": "jeremy williams",
      "text": "Stephanie was awesome!  Be sure to ask for her and nobody else.  She went above and beyond every step of the way.  Including giving me a call while moving in to make sure things were as they should be.",
      "date": "2025-09-08",
      "title": ""
    },
    {
      "id": "custom_4e7cbd99-3bfe-4363-a19c-451faee37baa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "rating": "5.0",
      "name": "Lori Ann",
      "text": "Love it here!! The maintenance team is the best! The manager, hands down is the greatest! The office staff are a 10!! The painter and porter are amazing!!",
      "date": "2025-08-19",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_30c89ccb-4fb2-4243-8ae4-39b15c5f5d7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb44-df80-75de-b5e1-52433f982999.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 degree view of the swimming pool area with lounge chairs and apartment buildings in the background",
        "public_id": "019cfb44-df80-75de-b5e1-52433f982999",
        "storage_key": "property/6767906449165615/019cfb44-df80-75de-b5e1-52433f982999.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Park at Coulter Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=6304b2aa3535377cb72ecf58&sourceId=1001"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-49b1-76fb-94a2-8933d63ba3c9",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "park-at-coulter",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615"
    },
    {
      "lead_collector_id": "019cf79e-4a32-74fa-813d-6d86c20dda37",
      "lead_source": "LANDING_PAGE",
      "name": "park-at-coulter",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "generator",
      "page_item_url": "dog-park-apartments-in-amarillo-tx",
      "search_query": "dog park apartments in Amarillo TX",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Amarillo, TX",
      "h2_subtitle": "Explore dog-friendly living at Park at Coulter. Experience convenience with nearby dog parks and pet-friendly amenities in Amarillo, TX.",
      "page_copy": "Welcome to Park at Coulter, the ideal destination for pet enthusiasts looking for dog park apartments in Amarillo, TX. Our community offers welcoming spaces perfect for you and your furry friends. While enjoying our cable-ready units and modern conveniences, you'll find that nearby dog parks provide great opportunities for outdoor fun with your pet. Additionally, our spacious one and two-bedroom floor plans ensure you and your pets have ample room to thrive. \n\nOur apartment community is not just about great homes; it's also about lifestyle amenities including a sparkling pool and a fully-equipped fitness center. We are proud of our pet-friendly policy, which makes life at Park at Coulter even more enjoyable. Plus, with wheelchair accessible rooms, it's easy to access everything the community offers. Discover why our dog park locations make Park at Coulter the perfect homes for both pets and their humans!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-f268-71bb-a7cc-ab34ff9af4eb.webp",
      "featured_image_media": {
        "alt_text": "Living room with fireplace, sofa, dining area, and bar seating.",
        "public_id": "019cfb43-f268-71bb-a7cc-ab34ff9af4eb",
        "storage_key": "property/6767906449165615/019cfb43-f268-71bb-a7cc-ab34ff9af4eb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Amarillo, TX",
      "seo_description": "Discover pet-friendly living at Park at Coulter in Amarillo, TX. Enjoy spacious apartments near dog parks & top amenities. Schedule a visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "generator",
      "page_item_url": "apartments-with-pool-near-southwest-amarillo",
      "search_query": "apartments with a pool near Southwest Amarillo",
      "category": "Amenity",
      "h1_title": "Apartments with a Pool near Southwest Amarillo",
      "h2_subtitle": "Dive into comfort at Park at Coulter, offering apartments with a pool near Southwest Amarillo. Enjoy our sparkling pool and top-notch amenities.",
      "page_copy": "Nestled in the heart of the community, Park at Coulter offers exceptional apartments with a pool near Southwest Amarillo. Our residents enjoy a refreshing oasis with a sparkling pool that is perfect for relaxation and recreation. Choose from our spacious one or two-bedroom floor plans, each designed with comfort and convenience in mind. \n\nIn addition to our inviting pool, Park at Coulter features a modern fitness center, a welcoming clubhouse, and a business center equipped with online services—ideal for a balanced lifestyle. Whether you're unwinding by the pool or exploring the vibrant neighborhood, our apartments provide the perfect retreat. Come visit us today to see why Park at Coulter is the ideal home in Southwest Amarillo.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-f268-71bb-a7cc-ab34ff9af4eb.webp",
      "featured_image_media": {
        "alt_text": "Living room with fireplace, sofa, dining area, and bar seating.",
        "public_id": "019cfb43-f268-71bb-a7cc-ab34ff9af4eb",
        "storage_key": "property/6767906449165615/019cfb43-f268-71bb-a7cc-ab34ff9af4eb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with a Pool near Southwest Amarillo",
      "seo_description": "Discover Park at Coulter's poolside living near Southwest Amarillo. Enjoy vibrant amenities and spacious floor plans. Tour our beautiful community today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-amarillo-79119",
      "search_query": "air conditioned apartments Amarillo 79119",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Amarillo 79119",
      "h2_subtitle": "Stay cool in Amarillo's 79119 at Park at Coulter. Our air conditioned apartments offer comfort and convenience in a prime location.",
      "page_copy": "Beat the Texas heat with the comfort of air conditioned apartments in Amarillo 79119 at Park at Coulter. Our community offers climate-controlled living spaces, designed to meet your needs and ensure year-round comfort. Select from our one or two-bedroom layouts, each equipped with modern amenities and spacious interiors. \n\nLiving at Park at Coulter means enjoying not only the cool relief of air conditioning but also a variety of onsite amenities like a refreshing swimming pool, a state-of-the-art fitness center, and a welcoming clubhouse. Positioned in the vibrant area of Amarillo 79119, our location provides easy access to local attractions and conveniences. Experience a comfortable lifestyle at Park at Coulter today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-f268-71bb-a7cc-ab34ff9af4eb.webp",
      "featured_image_media": {
        "alt_text": "Living room with fireplace, sofa, dining area, and bar seating.",
        "public_id": "019cfb43-f268-71bb-a7cc-ab34ff9af4eb",
        "storage_key": "property/6767906449165615/019cfb43-f268-71bb-a7cc-ab34ff9af4eb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Amarillo 79119",
      "seo_description": "Find air conditioned living at Park at Coulter in Amarillo 79119. Enjoy modern amenities and a prime location. Visit us and stay cool year-round!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "generator",
      "page_item_url": "apartments-with-dishwasher-in-randall-county",
      "search_query": "apartments with dishwasher in Randall County",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher in Randall County",
      "h2_subtitle": "Discover modern living at Park at Coulter. Enjoy the convenience of apartments with a dishwasher right in Randall County, Texas.",
      "page_copy": "At Park at Coulter, we prioritize convenience and modern living, offering apartments with a dishwasher in the desirable Randall County. Each of our spacious one and two-bedroom apartments comes with a fully equipped kitchen that includes a dishwasher, making meal preparation and clean-up a breeze. \n\nBeyond the kitchen, our community features amenities that cater to your lifestyle, such as a sparkling pool, a cutting-edge fitness center, and a welcoming clubhouse ideal for social gatherings. Located in the vibrant heart of Randall County, you're just minutes away from local attractions and conveniences. Discover the perfect blend of comfort and functionality at Park at Coulter today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-f268-71bb-a7cc-ab34ff9af4eb.webp",
      "featured_image_media": {
        "alt_text": "Living room with fireplace, sofa, dining area, and bar seating.",
        "public_id": "019cfb43-f268-71bb-a7cc-ab34ff9af4eb",
        "storage_key": "property/6767906449165615/019cfb43-f268-71bb-a7cc-ab34ff9af4eb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwasher in Randall County",
      "seo_description": "Enjoy the convenience of a dishwasher in Randall County at Park at Coulter. Discover modern floor plans and premium amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-in-south-amarillo",
      "search_query": "fitness center apartments in South Amarillo",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in South Amarillo",
      "h2_subtitle": "Experience active living at Park at Coulter, offering fitness center apartments in South Amarillo. Enjoy a modern workout space just steps from home.",
      "page_copy": "At Park at Coulter, staying fit and healthy is effortless with our well-equipped fitness center, perfect for our South Amarillo residents. Our apartments not only provide comfortable living but also offer direct access to a state-of-the-art fitness center, helping you maintain an active lifestyle without leaving the convenience of your home.\n\nChoose from our spacious one or two-bedroom floor plans, each designed with modern amenities and comfortable living in mind. Our community also features a sparkling pool and a welcoming clubhouse, making it a great place to relax after a workout. Located in South Amarillo, Park at Coulter provides you with the perfect blend of activity and relaxation. Visit us today and see how our community can enhance your lifestyle!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-f268-71bb-a7cc-ab34ff9af4eb.webp",
      "featured_image_media": {
        "alt_text": "Living room with fireplace, sofa, dining area, and bar seating.",
        "public_id": "019cfb43-f268-71bb-a7cc-ab34ff9af4eb",
        "storage_key": "property/6767906449165615/019cfb43-f268-71bb-a7cc-ab34ff9af4eb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in South Amarillo",
      "seo_description": "Find your active lifestyle at Park at Coulter. Enjoy fitness-focused amenities with our South Amarillo apartments, featuring an onsite gym.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-amarillo-tx",
      "search_query": "one bedroom apartments amarillo tx",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Amarillo, TX",
      "h2_subtitle": "Discover comfort and style at Park at Coulter with our one bedroom apartments in Amarillo, TX. Modern amenities and spacious designs await you.",
      "page_copy": "Explore the perfect blend of comfort and convenience with our one bedroom apartments in Amarillo, TX, at Park at Coulter. Ideal for singles or couples, these thoughtfully designed apartments are equipped with modern amenities, including a fully fitted kitchen and a spacious living area, catering to your lifestyle needs.\n\nBeyond your doorstep, enjoy the community's welcoming features such as a sparkling pool, a state-of-the-art fitness center, and an inviting clubhouse, perfect for social gatherings or quiet relaxation. Conveniently located in Amarillo, TX, Park at Coulter provides easy access to local dining, shopping, and entertainment options. Experience exceptional living by choosing a one bedroom apartment at our community today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-f268-71bb-a7cc-ab34ff9af4eb.webp",
      "featured_image_media": {
        "alt_text": "Living room with fireplace, sofa, dining area, and bar seating.",
        "public_id": "019cfb43-f268-71bb-a7cc-ab34ff9af4eb",
        "storage_key": "property/6767906449165615/019cfb43-f268-71bb-a7cc-ab34ff9af4eb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Amarillo, TX",
      "seo_description": "Explore one bedroom living at Park at Coulter in Amarillo, TX. Enjoy modern amenities and convenient access to local attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-79119",
      "search_query": "two bedroom apartments near 79119",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 79119",
      "h2_subtitle": "Find spacious two bedroom apartments at Park at Coulter, located near the 79119 area. Experience modern living with convenient access to local amenities.",
      "page_copy": "Experience the perfect home with our two bedroom apartments near the 79119 area at Park at Coulter. Designed with spaciousness and comfort in mind, these apartments provide ample room for families or roommates, featuring modern amenities such as a fully-equipped kitchen and plenty of living space.\n\nNestled in a prime location near the 79119 zip code, Park at Coulter offers additional conveniences such as a sparkling pool, a state-of-the-art fitness center, and an inviting clubhouse. This strategic location provides quick access to Amarillo's finest dining, shopping, and entertainment venues, making it an ideal choice for those seeking both comfort and convenience. Visit Park at Coulter and discover the ideal two bedroom apartment today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-f268-71bb-a7cc-ab34ff9af4eb.webp",
      "featured_image_media": {
        "alt_text": "Living room with fireplace, sofa, dining area, and bar seating.",
        "public_id": "019cfb43-f268-71bb-a7cc-ab34ff9af4eb",
        "storage_key": "property/6767906449165615/019cfb43-f268-71bb-a7cc-ab34ff9af4eb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near 79119",
      "seo_description": "Discover two bedroom living near 79119 at Park at Coulter. Enjoy spacious layouts and easy access to Amarillo attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "generator",
      "page_item_url": "apartments-near-amarillo-college",
      "search_query": "apartments near Amarillo College",
      "category": "School",
      "h1_title": "Apartments Near Amarillo College",
      "h2_subtitle": "Discover convenient living with apartments near Amarillo College at Park at Coulter. Enjoy easy commutes and comfortable amenities in Amarillo, TX.",
      "page_copy": "Looking for a convenient place to call home near Amarillo College? Park at Coulter offers the perfect solution with our well-appointed apartments. Located within a short drive of the college, our community provides an ideal setting for students and educators who desire a balance between academic and home life.\n\nOur spacious one and two-bedroom apartments come with a range of modern features and amenities including a sparkling pool, a state-of-the-art fitness center, and an inviting clubhouse. Enjoy the convenience of living near Amarillo College while benefitting from comfortable and stylish apartment living. Whether you're hitting the books or enjoying downtime, Park at Coulter offers everything you need in a vibrant community. Schedule a tour today to explore our apartments near Amarillo College!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-f268-71bb-a7cc-ab34ff9af4eb.webp",
      "featured_image_media": {
        "alt_text": "Living room with fireplace, sofa, dining area, and bar seating.",
        "public_id": "019cfb43-f268-71bb-a7cc-ab34ff9af4eb",
        "storage_key": "property/6767906449165615/019cfb43-f268-71bb-a7cc-ab34ff9af4eb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Amarillo College",
      "seo_description": "Find the ideal home near Amarillo College at Park at Coulter, offering modern amenities and easy access to campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "generator",
      "page_item_url": "apartments-close-to-amarillo-college-west-campus",
      "search_query": "apartments close to Amarillo College West Campus Amarillo",
      "category": "School",
      "h1_title": "Apartments Close to Amarillo College West",
      "h2_subtitle": "Explore apartments close to Amarillo College West Campus at Park at Coulter. Find a welcoming community with modern amenities right in Amarillo.",
      "page_copy": "Discover a seamless blend of comfort and convenience with apartments close to Amarillo College West Campus at Park at Coulter. Our community is perfect for students and faculty seeking a home just minutes away from the campus, offering an easy commute and more time for your studies and activities.\n\nPark at Coulter provides modern one and two-bedroom floor plans equipped with everything you need for a comfortable lifestyle, including a state-of-the-art fitness center, a sparkling pool, and an inviting clubhouse. Enjoy living in a vibrant neighborhood with quick access to shopping, dining, and entertainment options. Make Park at Coulter your new home and experience convenience at its finest near Amarillo College West Campus.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-f268-71bb-a7cc-ab34ff9af4eb.webp",
      "featured_image_media": {
        "alt_text": "Living room with fireplace, sofa, dining area, and bar seating.",
        "public_id": "019cfb43-f268-71bb-a7cc-ab34ff9af4eb",
        "storage_key": "property/6767906449165615/019cfb43-f268-71bb-a7cc-ab34ff9af4eb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Amarillo College West",
      "seo_description": "Live near Amarillo College West Campus at Park at Coulter, offering modern amenities and easy campus access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "generator",
      "page_item_url": "apartments-near-bsa-hospital-amarillo",
      "search_query": "apartments near BSA Hospital Amarillo",
      "category": "Hospital",
      "h1_title": "Apartments Near BSA Hospital Amarillo",
      "h2_subtitle": "Discover apartments near BSA Hospital in Amarillo at Park at Coulter. Enjoy modern living and convenient access to healthcare facilities and services.",
      "page_copy": "For those looking for apartments near BSA Hospital in Amarillo, Park at Coulter is an exceptional choice. Our community offers a perfect home base for healthcare professionals or patients needing proximity to BSA Hospital. With a variety of one and two-bedroom floor plans, you'll find the ideal living space equipped with modern conveniences.\n\nSituated near the heart of Amarillo, Park at Coulter provides more than just a strategic location; it offers amenities like a sparkling pool, state-of-the-art fitness center, and an inviting clubhouse. These features, combined with the ease of accessibility to BSA Hospital, make Park at Coulter a top choice for anyone seeking comfortable, high-quality living in the area. Tour our apartment community today and experience the advantages of living close to BSA Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-f268-71bb-a7cc-ab34ff9af4eb.webp",
      "featured_image_media": {
        "alt_text": "Living room with fireplace, sofa, dining area, and bar seating.",
        "public_id": "019cfb43-f268-71bb-a7cc-ab34ff9af4eb",
        "storage_key": "property/6767906449165615/019cfb43-f268-71bb-a7cc-ab34ff9af4eb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near BSA Hospital Amarillo",
      "seo_description": "Explore living near BSA Hospital with our apartments at Park at Coulter, offering comfort and easy access to healthcare.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "generator",
      "page_item_url": "apartments-close-to-northwest-texas-healthcare-system",
      "search_query": "apartments close to Northwest Texas Healthcare System 79119",
      "category": "Hospital",
      "h1_title": "Apartments Close to Northwest Texas Healthcare",
      "h2_subtitle": "Find premier apartments close to Northwest Texas Healthcare System at Park at Coulter. Experience modern amenities and convenience in the 79119 area.",
      "page_copy": "If you're searching for apartments close to Northwest Texas Healthcare System in the 79119 area, Park at Coulter is your perfect match. Our community caters to healthcare professionals and patients looking for convenient, comfortable living near the hospital. Our selection of one and two-bedroom floor plans offers a stylish and functional living space.\n\nPark at Coulter is equipped with all the amenities you desire, including a sparkling pool, a state-of-the-art fitness center, and an inviting clubhouse. Located in a vibrant area of Amarillo, our community offers quick access to healthcare facilities, shopping, and dining. Discover the benefits of living near Northwest Texas Healthcare System and make Park at Coulter your new home. Schedule a tour today and see everything we have to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-f268-71bb-a7cc-ab34ff9af4eb.webp",
      "featured_image_media": {
        "alt_text": "Living room with fireplace, sofa, dining area, and bar seating.",
        "public_id": "019cfb43-f268-71bb-a7cc-ab34ff9af4eb",
        "storage_key": "property/6767906449165615/019cfb43-f268-71bb-a7cc-ab34ff9af4eb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Northwest Texas Healthcare",
      "seo_description": "Live near Northwest Texas Healthcare System at Park at Coulter, featuring modern amenities in the 79119 area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "generator",
      "page_item_url": "apartments-near-amarillo-botanical-gardens",
      "search_query": "apartments near amarillo botanical gardens",
      "category": "Park",
      "h1_title": "Apartments Near Amarillo Botanical Gardens",
      "h2_subtitle": "Explore apartments near Amarillo Botanical Gardens at Park at Coulter. Enjoy a perfect blend of nature and modern living.",
      "page_copy": "Discover the ideal living experience with apartments near Amarillo Botanical Gardens at Park at Coulter. Immerse yourself in nature's beauty with easy access to the serene gardens while enjoying modern apartment amenities. Our community provides excellent options for those who appreciate a blend of tranquility and convenience.\n\nPark at Coulter offers spacious one and two-bedroom floor plans with contemporary features, ensuring a comfortable lifestyle. The community amenities, such as a sparkling pool, a state-of-the-art fitness center, and a welcoming clubhouse, complement the nearby botanical gardens. Located in Amarillo, you will enjoy both the natural beauty of the gardens and the vibrant city life. Make Park at Coulter your home and experience the best of both worlds.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-f268-71bb-a7cc-ab34ff9af4eb.webp",
      "featured_image_media": {
        "alt_text": "Living room with fireplace, sofa, dining area, and bar seating.",
        "public_id": "019cfb43-f268-71bb-a7cc-ab34ff9af4eb",
        "storage_key": "property/6767906449165615/019cfb43-f268-71bb-a7cc-ab34ff9af4eb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Amarillo Botanical Gardens",
      "seo_description": "Park at Coulter offers modern living near Amarillo Botanical Gardens, providing a blend of nature and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "generator",
      "page_item_url": "apartments-close-to-john-stiff-memorial-park",
      "search_query": "apartments close to john stiff memorial park amarillo 79119",
      "category": "Park",
      "h1_title": "Apartments Close to John Stiff Memorial Park",
      "h2_subtitle": "Discover apartments close to John Stiff Memorial Park in Amarillo, 79119. Enjoy park views and modern living at Park at Coulter.",
      "page_copy": "Looking for apartments close to John Stiff Memorial Park in Amarillo's 79119 zip code? Park at Coulter is perfectly situated for those who enjoy outdoor activities and scenic views. Our community offers vibrant living with easy access to the park's lush greenery and recreational facilities, ideal for nature enthusiasts and families alike.\n\nAt Park at Coulter, choose from a selection of modern one and two-bedroom floor plans equipped with all the conveniences of contemporary living. Enjoy community features like a refreshing pool, a state-of-the-art fitness center, and a welcoming clubhouse. Experience the best of outdoor and indoor living with a home that suits your lifestyle. Make Park at Coulter your next home and relish the proximity to John Stiff Memorial Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-f268-71bb-a7cc-ab34ff9af4eb.webp",
      "featured_image_media": {
        "alt_text": "Living room with fireplace, sofa, dining area, and bar seating.",
        "public_id": "019cfb43-f268-71bb-a7cc-ab34ff9af4eb",
        "storage_key": "property/6767906449165615/019cfb43-f268-71bb-a7cc-ab34ff9af4eb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near John Stiff Memorial Park Amarillo",
      "seo_description": "Live close to John Stiff Memorial Park at Park at Coulter in Amarillo, 79119, with modern amenities and scenic park views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "generator",
      "page_item_url": "apartment-living-wildcat-bluff-nature-center",
      "search_query": "apartment living by wildcat bluff nature center amarillo tx",
      "category": "Park",
      "h1_title": "Apartment Living by Wildcat Bluff Nature Center",
      "h2_subtitle": "Experience apartment living near Wildcat Bluff Nature Center in Amarillo, TX. Park at Coulter offers modern amenities in a natural setting.",
      "page_copy": "Embrace the beauty of nature with apartment living by Wildcat Bluff Nature Center in Amarillo, TX, at Park at Coulter. Our community provides a seamless mix of modern comfort and natural beauty, perfect for those who appreciate the serene environment of the nearby nature center.\n\nPark at Coulter features spacious one and two-bedroom floor plans with contemporary finishes. Delight in our amenities, including a sparkling pool, a top-of-the-line fitness center, and an inviting clubhouse. Located conveniently in Amarillo, TX, you have the opportunity to enjoy the tranquility of Wildcat Bluff Nature Center while benefiting from proximity to shopping and dining options. Choose Park at Coulter for a harmonious blend of nature and urban living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-f268-71bb-a7cc-ab34ff9af4eb.webp",
      "featured_image_media": {
        "alt_text": "Living room with fireplace, sofa, dining area, and bar seating.",
        "public_id": "019cfb43-f268-71bb-a7cc-ab34ff9af4eb",
        "storage_key": "property/6767906449165615/019cfb43-f268-71bb-a7cc-ab34ff9af4eb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Living Near Wildcat Bluff Nature Center",
      "seo_description": "Experience modern living by Wildcat Bluff Nature Center at Park at Coulter in Amarillo, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "generator",
      "page_item_url": "amarillo-apartments-next-to-memorial-park",
      "search_query": "amarillo tx apartments next to memorial park",
      "category": "Park",
      "h1_title": "Amarillo TX Apartments Next to Memorial Park",
      "h2_subtitle": "Find Amarillo TX apartments next to Memorial Park at Park at Coulter. Enjoy convenient living with extensive park amenities nearby.",
      "page_copy": "Discover convenient Amarillo TX apartments next to Memorial Park at Park at Coulter. Perfectly located, our community offers residents easy access to the lush landscapes and relaxing atmospheres of Memorial Park. Enjoy serene nature walks, outdoor activities, and community events just steps from your doorstep.\n\nPark at Coulter boasts spacious, modern one and two-bedroom floor plans designed for comfort and style. Engage with the vibrant community amenities such as our shimmering pool, a cutting-edge fitness center, and a welcoming clubhouse. Positioned in Amarillo, TX, you can indulge in the convenience of urban living with the peacefulness of Memorial Park right next door. Make Park at Coulter your new home today and relish in the perfect balance of lifestyle and location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-f268-71bb-a7cc-ab34ff9af4eb.webp",
      "featured_image_media": {
        "alt_text": "Living room with fireplace, sofa, dining area, and bar seating.",
        "public_id": "019cfb43-f268-71bb-a7cc-ab34ff9af4eb",
        "storage_key": "property/6767906449165615/019cfb43-f268-71bb-a7cc-ab34ff9af4eb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Amarillo Apartments Near Memorial Park",
      "seo_description": "Park at Coulter offers Amarillo TX apartments next to Memorial Park with modern amenities and park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165615",
      "source": "generator",
      "page_item_url": "rentals-near-medical-center-park-amarillo",
      "search_query": "rentals near medical center park amarillo",
      "category": "Park",
      "h1_title": "Rentals Near Medical Center Park Amarillo",
      "h2_subtitle": "Explore rentals near Medical Center Park in Amarillo. Park at Coulter offers ideal living with modern comforts and proximity to the medical center.",
      "page_copy": "Looking for rentals near Medical Center Park in Amarillo? Park at Coulter provides an exceptional living experience close to this important hub. Strategically located, our apartments offer the utmost convenience for medical professionals and families seeking proximity to healthcare services and lush park landscapes.\n\nOur community features spacious one and two-bedroom floor plans, each outfitted with contemporary amenities that cater to a modern lifestyle. Residents can enjoy on-site offerings such as a refreshing pool, a well-equipped fitness center, and a stylish clubhouse. Situated in Amarillo, Park at Coulter combines the advantages of city living with the tranquility of being near Medical Center Park. It's the perfect place to call home while enjoying close proximity to work and leisure activities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-f268-71bb-a7cc-ab34ff9af4eb.webp",
      "featured_image_media": {
        "alt_text": "Living room with fireplace, sofa, dining area, and bar seating.",
        "public_id": "019cfb43-f268-71bb-a7cc-ab34ff9af4eb",
        "storage_key": "property/6767906449165615/019cfb43-f268-71bb-a7cc-ab34ff9af4eb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Medical Center Park Amarillo",
      "seo_description": "Find spacious rentals near Medical Center Park in Amarillo at Park at Coulter, with modern amenities and easy access to healthcare facilities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5191"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-TLTLTGH61K"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151520"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/park-at-coulter/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TL9XN9L3"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165615/019d1bd8-f32e-70af-bf5d-d62d7dfab80b.pdf"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "7e6468fd-b811-435f-b2c4-9fa8032c9798"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "866-822-6519"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "6504af762eabfc86f4b0033c"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImY0Z0QzdlUyNWZrdkxocEJXZjA2NUE9PSIsInZhbHVlIjoiUW5BUEZxYzB6aUcxMmhiampTY29kZz09IiwibWFjIjoiOGY4Zjg3NThiYTIyOGNlNDhlOTE3YjdiODdhZWMzZTljM2YxMmViOTViN2MxZTgxZjk5MWMzODVlNzQyNDRkMCJ9"
    }
  ],
  "custom_qb_id": "5191",
  "custom_ga4_id": "G-TLTLTGH61K",
  "custom_repli_id": "10041151520",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/park-at-coulter/register/",
  "custom_google_gtm_id": "GTM-TL9XN9L3",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165615/019d1bd8-f32e-70af-bf5d-d62d7dfab80b.pdf",
  "custom_rentgrata_property_id": "7e6468fd-b811-435f-b2c4-9fa8032c9798",
  "custom_ppc_tracking_phone_number": "866-822-6519",
  "custom_residentboost_apartment_id": "6504af762eabfc86f4b0033c",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImY0Z0QzdlUyNWZrdkxocEJXZjA2NUE9PSIsInZhbHVlIjoiUW5BUEZxYzB6aUcxMmhiampTY29kZz09IiwibWFjIjoiOGY4Zjg3NThiYTIyOGNlNDhlOTE3YjdiODdhZWMzZTljM2YxMmViOTViN2MxZTgxZjk5MWMzODVlNzQyNDRkMCJ9"
};

export const generatedAt = '2026-08-27T21:37:30.363Z';
